import React, { useContext, useEffect, useRef, useState } from "react"
import useStyles from "./styles";
import { UserTypeContext } from "../../context/userStatus";
import moment from "moment";
import { trackingService } from "../../services/tracking";
import { setDayCompleteMessage } from "../../store/actions/trackerAction";
import { addCategoryJourneyAction, addJourneyAction, setOpenSubscriptionModal, setUserHeart, setUserStreak } from "../../store/actions/userTypeAction";
import palette from "../../theme/palette";
import { Box, Button, SvgIcon, Tooltip, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import clsx from "clsx"
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from "../../assets/images/icon/EditIcon";
import IconYesNo2 from "./IconYesNo2";
import CommonTypo from "../../components/CommonTypo";
import { baseEndpoints } from "../../services/config";
import { FontAwesomeIconRender, foundSelectedIcon, ICON_SLECTIN_TABS } from "../../components/IconSelectionPopOver";
import { fixOutcomeIcon } from "../../utils/staticDataJson";
import NewButton from "../../components/NewButton";
import CorrelationIcon from "../../assets/images/icon/ProgressInsights/CorrelationIcon";
import RightIconSwitch from "../../assets/images/icon/RightIconSwitch";
import MoveMetricPopover from "../trackerNewV2/MoveMetricPopover";
const DetailCard = (props) => {
    let noData = false
    const textareaRef = useRef<HTMLTextAreaElement>();
    const classes = useStyles();
    const [inputNotesValue, setNotesInputValue] = useState<any>("");
    const [inputValue, setInputValue] = useState("");
    const [isInFullView, setIsInFullView] = useState(false);
    const { state: outcomeState, dispatch: UserTypeDispatch } = useContext(UserTypeContext);
    const [showInput, setShowInput] = useState(false);
    const [showDescriptionInput, setShowDescriptionInput] = useState(false);
    const [visibleYesnotSwitch, setVisibleSwitch] = useState(false);
    const [visibleFullStepper, setVisibleFullStepper] = useState(false);
    const { trackingDispatch } = props
    const clickCondition = moment(props.betweenDate).isBetween(
        moment().subtract(8, "year").format("yyyy-MM-DD"),
        moment().add(1, "day").format("yyyy-MM-DD")
    );
    const isDarkMode = outcomeState.isDarkMode
    useEffect(() => {
        if (showDescriptionInput && textareaRef.current) {
            setTimeout(() => {
                const textarea = textareaRef.current;
                textarea.focus();
                textarea.selectionStart = textarea.selectionEnd = textarea.value.length;
            }, 0);
        }
    }, [showDescriptionInput]);
    const handleBlurInput = (id: any, index: any, date: any, e: any, mouseOut: boolean) => {
        if (mouseOut) {
            setShowInput(false);
            setNoData(true);
        }
        if (
            e.key === "Enter" ||
            e.keyCode == "37" ||
            e.keyCode == "38" ||
            e.keyCode == "39" ||
            e.keyCode == "40" ||
            mouseOut
        ) {
            if (props?.item?.absenceToggle) {
                if (parseInt(inputValue) >= 0 && parseInt(inputValue) <= 5) {
                    setShowInput(false);
                    props?.outcomeCreate(inputValue, props?.headerDate);
                } else {
                    props?.setShowSnakbar(true);
                    props?.setMsgType("error");
                    props?.setSnakbarMsg("Please enter value between 0 to 5");
                }
            } else {
                if (parseInt(inputValue) > 0 && parseInt(inputValue) <= 5) {
                    setShowInput(false);
                    props?.outcomeCreate(inputValue, props?.headerDate);
                } else {
                    props?.setShowSnakbar(true);
                    props?.setMsgType("error");
                    props?.setSnakbarMsg("Please enter value between 1 to 5");
                }
            }


            // down arrow key
            if (e.keyCode == "40" && index <= outcomeState?.outcomeList?.length - 1) {
                let nextId = "";
                let nextItem;
                for (let i = 0; i < outcomeState?.outcomeList?.length; i++) {
                    if (outcomeState?.outcomeList[i]._id === id) {
                        nextId = outcomeState?.outcomeList[i + 1]?._id;
                        nextItem = outcomeState?.outcomeList[i + 1];
                    }
                }
                props.setOutcomeId(nextId);
                props?.setItem(nextItem);
                setShowInput(true);
                setInputValue("");
            }

            // up arrow key
            if (e.keyCode == "38" && index <= outcomeState?.outcomeList?.length - 1) {
                let prevId = "";
                let prevItem;
                for (let i = 0; i < outcomeState?.outcomeList?.length; i++) {
                    if (outcomeState?.outcomeList[i]._id === id) {
                        prevId = outcomeState?.outcomeList[i - 1]?._id;
                        prevItem = outcomeState?.outcomeList[i - 1];
                    }
                }
                props.setOutcomeId(prevId);
                props?.setItem(prevItem);
                setShowInput(true);
                setInputValue("");
            }
            setNoData(true)
        }
    };

    const handleBlurInputInfluence = (type, e: any, mouseOut: boolean) => {
        if (mouseOut) {
            setShowInput(false);
            setNoData(true);
        }
        if (
            e.key === "Enter" ||
            e.keyCode === "37" ||
            e.keyCode === "38" ||
            e.keyCode === "39" ||
            e.keyCode === "40" ||
            mouseOut
        ) {
            if (type === "TYPE2" && inputValue) {
                if (props?.item?.absenceToggle) {
                    if (parseInt(inputValue) >= 0 && parseInt(inputValue) <= 5) {
                        setShowInput(false);
                        // setDisplayInput(true);
                        props?.influenceCreate(inputValue, props?.headerDate);
                    } else {
                        props?.setShowSnakbar(true);
                        props?.setMsgType("error");
                        props?.setSnakbarMsg("Please enter value between 0 to 5");
                    }
                } else {
                    if (parseInt(inputValue) > 0 && parseInt(inputValue) <= 5) {
                        setShowInput(false);
                        // setDisplayInput(true);
                        props?.influenceCreate(inputValue, props?.headerDate);
                    } else {
                        props?.setShowSnakbar(true);
                        props?.setMsgType("error");
                        props?.setSnakbarMsg("Please enter value between 1 to 5");
                    }
                }

            } else if (type === "TYPE12") {
                if (inputValue !== "" && !Number.isNaN(Number(inputValue))) {
                    props?.unitCreate(inputValue, props?.headerDate);
                    setShowInput(false);
                } else if (inputValue === "") { } else {
                    props?.setShowSnakbar(true);
                    props?.setMsgType("error");
                    props?.setSnakbarMsg("Please enter value in number");
                }

            } else {
                setShowInput(false);
                // setDisplayInput(true);
                inputValue && props?.unitCreate(inputValue, props?.headerDate);
            }
        }
    };
    const handleBlurInputAreaInfluence = (type, e: any, mouseOut, journey) => {
        e && e.stopPropagation && e.stopPropagation()
        if (mouseOut) {
            setShowDescriptionInput(false);
            if (props?.type === "outcome") {
                const outcomeCreateData: any = {
                    date: props.headerDate,
                    outcomeId: props?.item?.outcomeId,
                    note: [inputNotesValue],
                };
                if (Number(journey?.index) >= 0) {
                    outcomeCreateData.index = parseInt(journey?.index);
                    outcomeCreateData.answerId = journey?.answerId;
                    outcomeCreateData.score = journey?.score;
                }
                outcomeCreateData.note = outcomeCreateData.note.filter((it) => it);
                if (!outcomeState?.isPersonal) {
                    const foundOutcome = (outcomeState?.outcomeList || []).find(it => it.outcomeId === outcomeCreateData.outcomeId);
                    if (foundOutcome) {
                        const journyList = { ...(outcomeState?.journeyList || {}) } as any
                        const foundDateItemIcon = journyList.outcome_data.findIndex(it => it.outcomeId === outcomeCreateData.outcomeId && it?.date === outcomeCreateData.date)
                        if (foundDateItemIcon > -1) {
                            journyList.outcome_data[foundDateItemIcon] = {
                                ...foundOutcome,
                                ...outcomeCreateData,
                            }
                        } else {
                            journyList.outcome_data.push({
                                ...foundOutcome,
                                ...outcomeCreateData,
                            } as any)
                        }
                        UserTypeDispatch(addJourneyAction(journyList as any))
                    }
                } else {
                    const journeyCategoryList = [...(outcomeState?.journeyCategoryList || [])]
                    const foundOutcome = (journeyCategoryList
                        || []).findIndex(it => it.outcomeIds && it.outcomeIds.includes(outcomeCreateData.outcomeId));
                    if (foundOutcome > -1) {

                        const journyList = { ...(outcomeState?.journeyList || {}) } as any
                        const foundOutcomeNew = (outcomeState?.outcomeList || []).find(it => it.outcomeId === outcomeCreateData.outcomeId);
                        const foundDateItemIcon = journyList.outcome_data.findIndex(it => it.outcomeId === outcomeCreateData.outcomeId && it?.date === outcomeCreateData.date)
                        if (foundDateItemIcon > -1) {
                            journyList.outcome_data[foundDateItemIcon] = {
                                ...foundOutcomeNew,
                                ...outcomeCreateData,
                            }
                        } else {
                            journyList.outcome_data.push({
                                ...foundOutcomeNew,
                                ...outcomeCreateData,
                            } as any)
                        }
                        UserTypeDispatch(addJourneyAction(journyList as any))
                    } else {
                        const foundOther = (journeyCategoryList
                            || []).findIndex(it => it.name === "Other")
                        if (foundOther > -1) {
                            const journyList = { ...(outcomeState?.journeyList || {}) } as any
                            const foundOutcomeNew = (outcomeState?.outcomeList || []).find(it => it.outcomeId === outcomeCreateData.outcomeId);
                            const foundDateItemIcon = journyList.outcome_data.findIndex(it => it.outcomeId === outcomeCreateData.outcomeId && it?.date === outcomeCreateData.date)
                            if (foundDateItemIcon > -1) {
                                journyList.outcome_data[foundDateItemIcon] = {
                                    ...foundOutcomeNew,
                                    ...outcomeCreateData,
                                }
                            } else {
                                journyList.outcome_data.push({
                                    ...foundOutcomeNew,
                                    ...outcomeCreateData,
                                } as any)
                            }
                            UserTypeDispatch(addJourneyAction(journyList as any))
                        }
                    }
                }
                outcomeCreateData.note = outcomeCreateData.note && outcomeCreateData.note.length ? outcomeCreateData.note.filter((it) => it && it.trim().length) : [];
                trackingService
                    .outcomeCreate(outcomeState.token, outcomeCreateData)
                    .then((data) => {
                        setInputValue("")
                    })
                    .catch((error) => {
                        // setShowSnakbar(true);
                        // setSnakbarMsg(
                        //     error?.response?.data?.message
                        //         ? error?.response?.data?.message
                        //         : error?.message
                        // );
                        // setMsgType("error");
                    });
            }
            if (props?.type === "influence") {
                let outcomeCreateData
                if (clickCondition && type === "TYPE2") {
                    outcomeCreateData = {
                        date: props?.headerDate,
                        influenceId: props?.item?.influenceId,
                        answerId: journey?.answerId,
                        score: journey.score,
                        index: journey?.index,
                        note: inputNotesValue ? [inputNotesValue] : [],
                        type: "TYPE2",
                    };

                } else if (
                    ((clickCondition && props?.item?.type === "TYPE3") ||
                        (clickCondition &&
                            props?.item?.type === "TYPE1" &&
                            props?.item?.flag === "yes")) && !props?.item?.lockMatrix
                ) {
                    outcomeCreateData = {
                        influenceId: props.item?.influenceId,
                        levelReach: journey?.levelReach || journey?.score,
                        note: [inputNotesValue],
                        date: props?.headerDate,
                        flag: props?.item?.flag,
                        type: props?.item?.type,
                        inverse: props?.item?.inverse,
                        colorCode: journey?.colorCode
                    };
                } else if (
                    clickCondition &&
                    props?.item?.type === "TYPE12" &&
                    props?.item?.flag === "no" && !props?.item?.lockMatrix && props?.item?.unitValue !== "timeofday"
                ) {
                    outcomeCreateData = {
                        influenceId: props.item?.influenceId,
                        score: journey?.score,
                        note: [inputNotesValue],
                        answerId: journey?.answerId,
                        date: props?.headerDate,
                        type: "TYPE12",
                    };
                } else if (props?.item?.type === "TYPE12" && clickCondition &&
                    props?.item?.unitValue === "timeofday" &&
                    props?.item?.metric_type === "NEUTRAL") {
                    outcomeCreateData = {
                        influenceId: props.item?.influenceId,
                        note: [inputNotesValue],
                        date: props?.headerDate,
                        type: props?.item?.type,
                        timeOfDay: journey.timeOfDay,
                        response_type: "TIME_OF_THE_DAY",
                    };
                }
                let oldData: any = {}
                if (!outcomeState?.isPersonal) {
                    const foundOutcome = (outcomeState?.influenceList || []).find(it => it.influenceId === outcomeCreateData.influenceId);
                    if (foundOutcome) {
                        const journyList = { ...(outcomeState?.journeyList || {}) } as any
                        const foundDateItemIcon = journyList.influence_data.findIndex(it => it.influenceId === outcomeCreateData.influenceId && it?.date === outcomeCreateData.date)
                        if (foundDateItemIcon > -1) {
                            oldData = { ...journyList.influence_data[foundDateItemIcon] }
                        }
                    }
                } else {
                    const journeyCategoryList = [...(outcomeState?.journeyCategoryList || [])]
                    const foundOutcome = (journeyCategoryList
                        || []).findIndex(it => it.influenceIds && it.influenceIds.includes(outcomeCreateData.influenceId));
                    if (foundOutcome > -1) {
                        if (journeyCategoryList[foundOutcome].alls && journeyCategoryList[foundOutcome].alls.length) {
                            const foundIndex = journeyCategoryList[foundOutcome].alls.findIndex(it => it.influenceId === outcomeCreateData.influenceId)
                            if (foundIndex > -1) {
                                if (journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses && journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses.length) {
                                    const foundDateValue = journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses.findIndex(it => it.date === outcomeCreateData.date)
                                    if (foundDateValue > -1) {
                                        oldData = { ...journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses[foundDateValue] }
                                    }
                                }
                            }
                        }
                    } else {
                        const foundOther = (journeyCategoryList || []).findIndex(it => it.name === "Other")
                        if (foundOther > -1) {
                            const outcomeFound = journeyCategoryList[foundOther].influences.findIndex(it => it.influenceId === outcomeCreateData.influenceId);
                            if (outcomeFound > -1) {
                                if (journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses && journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses.length) {
                                    const foundDateValue = journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses.findIndex(it => it.date === outcomeCreateData.date)
                                    if (foundDateValue > -1) {
                                        oldData = { ...journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses[foundDateValue] }
                                    }
                                }
                            }
                        }
                    }
                }
                const foundOutcome = (outcomeState?.influenceList || []).find(it => it.influenceId === outcomeCreateData.influenceId);
                if (foundOutcome) {
                    const journyList = { ...(outcomeState?.journeyList || {}) } as any
                    const foundDateItemIcon = journyList.influence_data.findIndex(it => it.influenceId === outcomeCreateData.influenceId && it?.date === outcomeCreateData.date)
                    if (foundDateItemIcon > -1) {
                        journyList.influence_data[foundDateItemIcon] = {
                            ...foundOutcome,
                            ...outcomeCreateData,
                        }
                    } else {
                        journyList.influence_data.push({
                            ...foundOutcome,
                            ...outcomeCreateData,
                        } as any)
                    }
                    UserTypeDispatch(addJourneyAction(journyList as any))
                    // if (props.callToGetData) {
                    //   props?.callService();
                    // }
                }
                console.log("outcomeCreateData ???", outcomeCreateData);
                
                outcomeCreateData.note = outcomeCreateData.note && outcomeCreateData.note.length ? outcomeCreateData.note.filter((it) => it && it.trim().length) : [];
                trackingService
                    .influenceCreate(outcomeState.token, outcomeCreateData)
                    .then((data) => {

                        // setInputValue("");
                    })
                    .catch((error) => {

                    });
            }
            if (props?.type === "reflective") {
                let bodyData = {
                    reflectiveId: props?.item?.reflectiveId,
                    answers: [inputNotesValue]
                        .filter((it) => it && it !== "\n")
                        .join("\n")
                        .split("\n"),
                    date: props.headerDate,
                };
                bodyData.answers = bodyData.answers.filter((it) => it && it !== "\n");
                if (!outcomeState?.isPersonal) {
                    const foundOutcome = (outcomeState?.reflectiveList || []).find(it => it.reflectiveId === bodyData.reflectiveId);
                    if (foundOutcome) {
                        const journyList = { ...(outcomeState?.journeyList || {}) } as any
                        const foundDateItemIcon = journyList.reflective_data.findIndex(it => it.reflectiveId === bodyData.reflectiveId && it?.date === bodyData.date)
                        if (foundDateItemIcon > -1) {
                            journyList.reflective_data[foundDateItemIcon] = {
                                ...foundOutcome,
                                ...bodyData,
                            }
                        } else {
                            journyList.reflective_data.push({
                                ...foundOutcome,
                                ...bodyData,
                            } as any)
                        }
                        UserTypeDispatch(addJourneyAction(journyList as any))
                    }
                } else {
                    const journeyCategoryList = [...(outcomeState?.journeyCategoryList || [])]
                    const foundOutcome = (journeyCategoryList
                        || []).findIndex(it => it.outcomeIds && it.outcomeIds.includes(bodyData.reflectiveId));
                    if (foundOutcome > -1) {

                        const journyList = { ...(outcomeState?.journeyList || {}) } as any
                        const foundOutcomeNew = (outcomeState?.reflectiveList || []).find(it => it.reflectiveId === bodyData.reflectiveId);
                        const foundDateItemIcon = journyList.reflective_data.findIndex(it => it.reflectiveId === bodyData.reflectiveId && it?.date === bodyData.date)
                        if (foundDateItemIcon > -1) {
                            journyList.reflective_data[foundDateItemIcon] = {
                                ...foundOutcomeNew,
                                ...bodyData,
                            }
                        } else {
                            journyList.reflective_data.push({
                                ...foundOutcomeNew,
                                ...bodyData,
                            } as any)
                        }
                        UserTypeDispatch(addJourneyAction(journyList as any))
                    } else {
                        const foundOther = (journeyCategoryList
                            || []).findIndex(it => it.name === "Other")
                        if (foundOther > -1) {
                            const journyList = { ...(outcomeState?.journeyList || {}) } as any
                            const foundOutcomeNew = (outcomeState?.reflectiveList || []).find(it => it.reflectiveId === bodyData.reflectiveId);
                            const foundDateItemIcon = journyList.reflective_data.findIndex(it => it.reflectiveId === bodyData.reflectiveId && it?.date === bodyData.date)
                            if (foundDateItemIcon > -1) {
                                journyList.reflective_data[foundDateItemIcon] = {
                                    ...foundOutcomeNew,
                                    ...bodyData,
                                }
                            } else {
                                journyList.reflective_data.push({
                                    ...foundOutcomeNew,
                                    ...bodyData,
                                } as any)
                            }
                            UserTypeDispatch(addJourneyAction(journyList as any))
                        }
                    }
                }
                trackingService
                    .refQuesCreate(outcomeState.token, bodyData)
                    .then((data) => { })
                    .catch((error) => {
                        // setShowSnakbar(true);
                        // setSnakbarMsg(
                        //     error?.response?.data?.description
                        //         ? error?.response?.data?.description
                        //         : error?.message
                        // );
                        // setMsgType("error");
                    });
            }
        }


        // }
    };
    const journeyDataOutcome: any = outcomeState?.journeyList?.outcome_data;
    const journeyDataInfluence: any = outcomeState?.journeyList?.influence_data;
    const journeyDataReflective: any = outcomeState?.journeyList?.reflective_data;
    const [NoData, setNoData] = useState(true);
    let foundData: any = false
    if (props?.item?.outcomeId && journeyDataOutcome && journeyDataOutcome.length) {
        foundData = journeyDataOutcome.find(journey => journey?.outcomeId === props?.item?.outcomeId && journey?.date === props.headerDate)
    }
    if (props?.item?.influenceId && journeyDataInfluence && journeyDataInfluence.length) {
        foundData = journeyDataInfluence.find(journey => journey?.influenceId === props?.item?.influenceId &&
            journey?.date === props.headerDate)
    }
    if (props?.item?.reflectiveId && journeyDataReflective && journeyDataReflective.length) {
        foundData = journeyDataReflective.find(journey => journey?.reflectiveId === props?.item?.reflectiveId &&
            journey?.date === props.headerDate)
        if (foundData && foundData.answers && !foundData.answers.length) {
            foundData = false
        }

    }
    const isToday = moment(props.headerDate, "mm-DD-yyyy").format("mm-DD-yyyy") === moment(new Date()).format("MM-DD-yyyy")
    const nearestValueOutcome = (val, influenceItem) => {
        let arr = [];

        if (influenceItem.outcomeId && influenceItem?.options?.length && influenceItem?.options[val - 1]) {
            return influenceItem.options[val - 1].colorCode
        }
        if (influenceItem?.options && influenceItem?.options.length) {
            arr = [...influenceItem?.options].map(it => it.value)
        }
        const returnVal = arr.reduce((p, n) => (Math.abs(p) > Math.abs(n - val) ? n - val : p), Infinity) + val
        if (influenceItem?.options && influenceItem?.options.length) {
            const foundIndexOfValue = influenceItem?.options.findIndex(it => it.value === returnVal)
            if (foundIndexOfValue > -1) {
                return influenceItem?.options[foundIndexOfValue]?.colorCode
            }
        }
        return false
    }
    const closest = (needle, haystack = []) => {
        if (haystack && haystack.length) {
            return haystack.reduce((a, b) => {
                let aDiff = Math.abs(a - needle);
                let bDiff = Math.abs(b - needle);

                if (aDiff == bDiff) {
                    return a > b ? a : b;
                } else {
                    return bDiff < aDiff ? b : a;
                }
            });
        }
        return -1

    }

    const nearestValue = (val, influenceItem) => {

        let arr = [];
        if (influenceItem?.options && influenceItem?.options.length) {
            arr = [...influenceItem?.options].map(it => it.value)
        }
        if (influenceItem.type === "TYPE2" && influenceItem.options.length && influenceItem.options[val - 1]) {
            return influenceItem.options[val - 1].colorCode
        }
        const returnVal = closest(val, arr)
        if (influenceItem?.options && influenceItem?.options.length && returnVal > -1) {
            const foundIndexOfValue = influenceItem?.options.findIndex(it => it.value === returnVal)
            if (foundIndexOfValue > -1) {
                return influenceItem?.options[foundIndexOfValue]?.colorCode
            }
        }
        return false

    }
    const createInfluence = (isEdit, answerId, score, outcomeNotes, optionIndex, type) => {
        let outcomeCreateData
        if (isEdit) {
            outcomeCreateData = {
                date: props?.headerDate,
                influenceId: props.item?.influenceId,
                answerId: answerId,
                score: score,
                index: optionIndex,
                note:
                    outcomeNotes,
                Type: type,
            };
        } else {
            outcomeCreateData = {
                date: props?.headerDate,
                influenceId: props.item?.influenceId,
                answerId: answerId,
                score: score,
                index: parseInt(optionIndex),
                note:
                    outcomeNotes,
                Type: type,
            };
        }
        const foundOutcome = (outcomeState?.influenceList || []).find(it => it.influenceId === outcomeCreateData.influenceId);
        if (foundOutcome) {
            const journyList = { ...(outcomeState?.journeyList || {}) } as any
            const foundDateItemIcon = journyList.influence_data.findIndex(it => it.influenceId === outcomeCreateData.influenceId && it?.date === outcomeCreateData.date)
            if (foundDateItemIcon > -1) {
                journyList.influence_data[foundDateItemIcon] = {
                    ...foundOutcome,
                    ...outcomeCreateData,
                }
            } else {
                journyList.influence_data.push({
                    ...foundOutcome,
                    ...outcomeCreateData,
                } as any)
            }
            UserTypeDispatch(addJourneyAction(journyList as any))
            // if (props.callToGetData) {
            //   props?.callService();
            // }
        }
        trackingService
            .influenceCreate(outcomeState.token, outcomeCreateData).then((data) => {
                if (data.showMessage && props?.headerDate === moment().format("MM-DD-YYYY")) {
                    trackingDispatch(setDayCompleteMessage({
                        open: data.showMessage,
                        message: data.message
                    }))
                }
                if (data.dataStreak) {
                    UserTypeDispatch(setUserStreak())
                }
                if (data.heartIncreaseFlag) {
                    UserTypeDispatch(setUserHeart())
                }
                setIsInFullView(false)
                // props?.callService();
            })
    }
    const createOutcome = (isEdit, answerId, score, outcomeNotes, optionIndex) => {
        let outcomeCreateData;
        if (isEdit) {
            outcomeCreateData = {
                date: props?.headerDate,
                outcomeId: props.item?.outcomeId,
                answerId: answerId,
                score: score,
                index: optionIndex,
                note:
                    outcomeNotes,
            };
        } else {
            outcomeCreateData = {
                date: props?.headerDate,
                outcomeId: props.item?.outcomeId,
                answerId: answerId,
                score: score,
                index: parseInt(optionIndex),
                note:
                    outcomeNotes,
            };
        }
        if (!outcomeState?.isPersonal) {
            const foundOutcome = (outcomeState?.outcomeList || []).find(it => it.outcomeId === outcomeCreateData.outcomeId);
            if (foundOutcome) {
                const journyList = { ...(outcomeState?.journeyList || {}) } as any
                const foundDateItemIcon = journyList.outcome_data.findIndex(it => it.outcomeId === outcomeCreateData.outcomeId && it?.date === outcomeCreateData.date)


                if (foundDateItemIcon > -1) {
                    journyList.outcome_data[foundDateItemIcon] = {
                        ...foundOutcome,
                        ...outcomeCreateData,
                    }
                } else {
                    journyList.outcome_data.push({
                        ...foundOutcome,
                        ...outcomeCreateData,
                    } as any)
                }
                UserTypeDispatch(addJourneyAction(journyList as any))
            }
        } else {
            const journeyCategoryList = [...(outcomeState?.journeyCategoryList || [])]
            const foundOutcome = (journeyCategoryList
                || []).findIndex(it => it.outcomeIds && it.outcomeIds.includes(outcomeCreateData.outcomeId));
            if (foundOutcome > -1) {

                const journyList = { ...(outcomeState?.journeyList || {}) } as any
                const foundOutcomeNew = (outcomeState?.outcomeList || []).find(it => it.outcomeId === outcomeCreateData.outcomeId);
                const foundDateItemIcon = journyList.outcome_data.findIndex(it => it.outcomeId === outcomeCreateData.outcomeId && it?.date === outcomeCreateData.date)
                if (foundDateItemIcon > -1) {
                    journyList.outcome_data[foundDateItemIcon] = {
                        ...foundOutcomeNew,
                        ...outcomeCreateData,
                    }
                } else {
                    journyList.outcome_data.push({
                        ...foundOutcomeNew,
                        ...outcomeCreateData,
                    } as any)
                }
                UserTypeDispatch(addJourneyAction(journyList as any))
            } else {
                const foundOther = (journeyCategoryList
                    || []).findIndex(it => it.name === "Other")
                if (foundOther > -1) {
                    const journyList = { ...(outcomeState?.journeyList || {}) } as any
                    const foundOutcomeNew = (outcomeState?.outcomeList || []).find(it => it.outcomeId === outcomeCreateData.outcomeId);
                    const foundDateItemIcon = journyList.outcome_data.findIndex(it => it.outcomeId === outcomeCreateData.outcomeId && it?.date === outcomeCreateData.date)
                    if (foundDateItemIcon > -1) {
                        journyList.outcome_data[foundDateItemIcon] = {
                            ...foundOutcomeNew,
                            ...outcomeCreateData,
                        }
                    } else {
                        journyList.outcome_data.push({
                            ...foundOutcomeNew,
                            ...outcomeCreateData,
                        } as any)
                    }
                    UserTypeDispatch(addJourneyAction(journyList as any))
                }
            }
        }
        trackingService
            .outcomeCreate(outcomeState.token, outcomeCreateData)
            .then((data) => {
                if (data.showMessage && props?.headerDate === moment().format("MM-DD-YYYY")) {
                    trackingDispatch(setDayCompleteMessage({
                        open: true,
                        message: data.message
                    }))
                }
                if (data.dataStreak) {
                    UserTypeDispatch(setUserStreak())
                }
                if (data.heartIncreaseFlag) {
                    UserTypeDispatch(setUserHeart())
                }
                setIsInFullView(false)
                // props?.callService();
            })
    }
    const createInfluenceLevel = (inputLevel, notes) => {
        let outcomeCreateData;

        outcomeCreateData = {
            influenceId: props.item?.influenceId,
            levelReach: inputLevel,
            note: notes,
            date: props?.headerDate,
            flag: props?.item?.flag,
            type: props?.item?.type,
            inverse: props?.item?.inverse,
            colorCode: (props?.item?.type === "TYPE3" &&
                inputLevel === "No") ||
                inputLevel === "No"
                ? props?.item?.inverse === "true"
                    ? palette.primary.main
                    : "#F17F79"
                : props?.item?.inverse === "true"
                    ? "#F17F79"
                    : palette.primary.main
        };
        const foundOutcome = (outcomeState?.influenceList || []).find(it => it.influenceId === outcomeCreateData.influenceId);
        if (foundOutcome) {
            const journyList = { ...(outcomeState?.journeyList || {}) } as any
            const foundDateItemIcon = journyList.influence_data.findIndex(it => it.influenceId === outcomeCreateData.influenceId && it?.date === outcomeCreateData.date)
            if (foundDateItemIcon > -1) {
                journyList.influence_data[foundDateItemIcon] = {
                    ...foundOutcome,
                    ...outcomeCreateData,
                }
            } else {
                journyList.influence_data.push({
                    ...foundOutcome,
                    ...outcomeCreateData,
                } as any)
            }
            UserTypeDispatch(addJourneyAction(journyList as any))
            setVisibleSwitch(false)
            // if (props.callToGetData) {
            //   props?.callService();
            // }
        }
        trackingService
            .influenceCreate(outcomeState.token, outcomeCreateData)
            .then((data) => {
                if (data.showMessage && props?.headerDate === moment().format("MM-DD-YYYY")) {
                    trackingDispatch(setDayCompleteMessage({
                        open: data.showMessage,
                        message: data.message
                    }))
                }
                if (data.dataStreak) {
                    UserTypeDispatch(setUserStreak())
                }
                if (data.heartIncreaseFlag) {
                    UserTypeDispatch(setUserHeart())
                }
                props.setShowSnakbar(false);
                props.setSnakbarMsg(data?.message);
                props.setOpenYesNoModal(false);
                // props?.callService();
                props.setMsgType("success");
            })
            .catch((error) => {
                props.setShowSnakbar(true);
                props.setSnakbarMsg(
                    error?.response?.data?.description
                        ? error?.response?.data?.description
                        : error?.message
                );
                props.setMsgType("error");
            });

    };

    const handleDeleteEntry = (outcomeId) => {
        let payload = {
            outcomeId: outcomeId,
            date: props?.headerDate,
        };
        if (!outcomeState?.isPersonal) {
            const foundOutcome = (outcomeState?.outcomeList || []).find(
                (it) => it.outcomeId === payload.outcomeId
            );
            if (foundOutcome) {
                const journyList = { ...(outcomeState?.journeyList || {}) } as any;
                const foundDateItemIcon = journyList.outcome_data.findIndex(
                    (it) =>
                        it.outcomeId === payload.outcomeId && it?.date === payload.date
                );
                if (foundDateItemIcon > -1) {
                    journyList.outcome_data.splice(foundDateItemIcon, 1);
                    UserTypeDispatch(addJourneyAction(journyList as any));
                    // if (props.callToGetData) {
                    //     props?.callService(false);
                    // }
                }
            }
        } else {
            const journeyCategoryList = [
                ...(outcomeState?.journeyCategoryList || []),
            ];
            const foundOutcome = (journeyCategoryList || []).findIndex(
                (it) => it.outcomeIds && it.outcomeIds.includes(payload.outcomeId)
            );
            if (foundOutcome > -1) {
                if (
                    journeyCategoryList[foundOutcome].alls &&
                    journeyCategoryList[foundOutcome].alls.length
                ) {
                    const foundIndex = journeyCategoryList[
                        foundOutcome
                    ].alls.findIndex((it) => it.outcomeId === payload.outcomeId);

                    if (foundIndex > -1) {
                        if (
                            journeyCategoryList[foundOutcome].alls[foundIndex]
                                .outcomesResponses &&
                            journeyCategoryList[foundOutcome].alls[foundIndex]
                                .outcomesResponses.length
                        ) {
                            const foundDateValue = journeyCategoryList[foundOutcome].alls[
                                foundIndex
                            ].outcomesResponses.findIndex(
                                (it) => it.date === payload.date
                            );
                            if (foundDateValue > -1) {
                                journeyCategoryList[foundOutcome].alls[
                                    foundIndex
                                ].outcomesResponses.splice(foundDateValue, 1);
                                UserTypeDispatch(
                                    addCategoryJourneyAction(journeyCategoryList)
                                );
                            }
                        }
                    }
                }
            } else {
                const foundOther = (journeyCategoryList || []).findIndex(
                    (it) => it.name === "Other"
                );
                if (foundOther > -1) {
                    const outcomeFound = journeyCategoryList[
                        foundOther
                    ].outcomes.findIndex((it) => it.outcomeId === payload.outcomeId);
                    if (outcomeFound > -1) {
                        if (
                            journeyCategoryList[foundOther].outcomes[outcomeFound]
                                .outcomesResponses &&
                            journeyCategoryList[foundOther].outcomes[outcomeFound]
                                .outcomesResponses.length
                        ) {
                            const foundDateValue = journeyCategoryList[
                                foundOther
                            ].outcomes[outcomeFound].outcomesResponses.findIndex(
                                (it) => it.date === payload.date
                            );
                            if (foundDateValue > -1) {
                                journeyCategoryList[foundOther].outcomes[
                                    outcomeFound
                                ].outcomesResponses.splice(foundDateValue, 1);
                                UserTypeDispatch(
                                    addCategoryJourneyAction(journeyCategoryList)
                                );
                            }
                        }
                    }
                }
            }
            const foundOutcomePersnal = (outcomeState?.outcomeList || []).find(
                (it) => it.outcomeId === payload.outcomeId
            );

            if (foundOutcomePersnal) {
                const journyList = { ...(outcomeState?.journeyList || {}) } as any;
                const foundDateItemIcon = journyList.outcome_data.findIndex(
                    (it) =>
                        it.outcomeId === payload.outcomeId && it?.date === payload.date
                );
                if (foundDateItemIcon > -1) {
                    journyList.outcome_data.splice(foundDateItemIcon, 1);
                    UserTypeDispatch(addJourneyAction(journyList as any));
                    // if (props.callToGetData) {
                    //     props?.callService(false);
                    // }
                }
            }
            if (props.callService) {
                // props?.callService(false);
            }
        }
        trackingService
            .deleteOutcomeRes(outcomeState.token, payload)
            .then((data) => {

                props.setShowSnakbar(false);
                props.setSnakbarMsg(data?.message);
                props.setOpenTrackingEventModal(false);
                // props?.callService(false);
                props.setMsgType("success");
            })
            .catch((error) => {
                props.setShowSnakbar(true);
                props.setSnakbarMsg(
                    error?.response?.data?.description
                        ? error?.response?.data?.description
                        : error?.message
                );
                props.setMsgType("error");
            });
    };
    const handleDeleteEntryInfluence = (influenceId) => {
        let payload = {
            influenceId: influenceId,
            date: props?.headerDate,
        };
        if (!outcomeState?.isPersonal) {
            const foundOutcome = (outcomeState?.influenceList || []).find(it => it.influenceId === payload.influenceId);
            if (foundOutcome) {
                const journyList = { ...(outcomeState?.journeyList || {}) } as any
                const foundDateItemIcon = journyList.influence_data.findIndex(it => it.influenceId === payload.influenceId && it?.date === payload.date)
                if (foundDateItemIcon > -1) {
                    journyList.influence_data.splice(foundDateItemIcon, 1)
                }
                UserTypeDispatch(addJourneyAction(journyList as any))
                // if (props.callToGetData) {
                //   props?.callService(false);
                // }
            }
        } else {
            // if (true) {
            //     const foundOutcome = (outcomeState?.influenceList || []).find(it => it.influenceId === payload.influenceId);
            //     if (foundOutcome) {
            //         const journyList = { ...(outcomeState?.journeyList || {}) } as any
            //         const foundDateItemIcon = journyList.influence_data.findIndex(it => it.influenceId === payload.influenceId && it?.date === payload.date)
            //         if (foundDateItemIcon > -1) {
            //             journyList.influence_data.splice(foundDateItemIcon, 1)
            //         }
            //         UserTypeDispatch(addJourneyAction(journyList as any))
            //         // if (props.callToGetData) {
            //         //   props?.callService(false);
            //         // }
            //     }
            // }
            const journeyCategoryList = [...(outcomeState?.journeyCategoryList || [])]
            const foundOutcome = (journeyCategoryList
                || []).findIndex(it => it.influenceIds && it.influenceIds.includes(payload.influenceId));

            if (foundOutcome > -1) {
                if (journeyCategoryList[foundOutcome].alls && journeyCategoryList[foundOutcome].alls.length) {
                    const foundIndex = journeyCategoryList[foundOutcome].alls.findIndex(it => it.influenceId === payload.influenceId)
                    if (foundIndex > -1) {
                        if (journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses && journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses.length) {
                            const foundDateValue = journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses.findIndex(it => it.date === payload.date)
                            if (foundDateValue > -1) {
                                journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses.splice(foundDateValue, 1)
                            }
                        }
                        UserTypeDispatch(addCategoryJourneyAction(journeyCategoryList));
                    }
                }
            } else {
                const foundOther = (journeyCategoryList || []).findIndex(it => it.name === "Other")
                if (foundOther > -1) {
                    const outcomeFound = journeyCategoryList[foundOther].influences.findIndex(it => it.influenceId === payload.influenceId);
                    if (outcomeFound > -1) {
                        if (journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses && journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses.length) {
                            const foundDateValue = journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses.findIndex(it => it.date === payload.date)
                            if (foundDateValue > -1) {
                                journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses.splice(foundDateValue, 1)
                            }
                        }
                        UserTypeDispatch(addCategoryJourneyAction(journeyCategoryList));
                    }
                }
            }
            const foundOutcomePersonal = (outcomeState?.influenceList || []).find(it => it.influenceId === payload.influenceId);
            if (foundOutcomePersonal) {
                const journyList = { ...(outcomeState?.journeyList || {}) } as any
                const foundDateItemIcon = journyList.influence_data.findIndex(it => it.influenceId === payload.influenceId && it?.date === payload.date)
                if (foundDateItemIcon > -1) {
                    journyList.influence_data.splice(foundDateItemIcon, 1)
                }
                UserTypeDispatch(addJourneyAction(journyList as any))
                // if (props.callToGetData) {
                //   props?.callService(false);
                // }
            }
            if (props.callService) {
                // props?.callService(false);
            }
        }
        trackingService
            .deleteInfluenceRes(outcomeState.token, payload)
            .then((data) => {

                // setShowLoadingBtn(false);
                // props.setShowSnakbar(true);
                props.setSnakbarMsg(data?.message);
                props.setOpenTrackingEventModal(false);
                // props?.callService(false);
                props.setMsgType("success");

            })
            .catch((error) => {
                // setShowLoadingBtn(false);
                props.setShowSnakbar(true);
                props.setSnakbarMsg(
                    error?.response?.data?.description
                        ? error?.response?.data?.description
                        : error?.message
                );
                props.setMsgType("error");
            });
    };
    const { expandedLevelView } = props

    const levelRender = (itemObject, options) => {
        let optionsData = options?.options || []
        if (options.absenceToggle) {
            optionsData = [{
                colorCode: "grey", score: 0, text: "Absence"
            }, ...optionsData]
        }
        if (expandedLevelView) {
            optionsData = [...optionsData].reverse()
        }

        const tickMark = null // <div className={ expandedLevelView? classes.tickMarkNew : classes.tickMark}></div>

        const checkAndReturnFullView = (index) => {
            let fullView = false;
            if (expandedLevelView) {
                if (!isInFullView) {
                    if (Number(itemObject?.index) > -1) {
                        if (options.absenceToggle && itemObject?.index === parseInt(index)) {
                            fullView = true
                        }
                        if (!options.absenceToggle && itemObject?.index === (parseInt(index) + 1)) {
                            fullView = true
                        }
                    } else if (!itemObject?.index) {
                        fullView = true
                    }
                } else {
                    fullView = true
                }
            }
            return fullView
        }
        return <>
            {!expandedLevelView && <div style={{
                width: '100%',
                // height: '1px',
                // transform: 'rotate(-90deg)',
                flexShrink: 0,
                strokeWidth: '100%',
                background: '#DCE5E0',
                position: 'absolute',
                top: '50%'
            }}>

            </div>}
            {!visibleFullStepper && (Number(itemObject?.index) >= 0) ? (
                <div className={expandedLevelView ? classes.selectionExpanded : classes.selection} onClick={(e) => {
                    e.stopPropagation()
                    if (options.influenceId) {
                        if (options.absenceToggle) {
                            handleDeleteEntryInfluence(options?.influenceId)
                        } else if (!options.absenceToggle) {
                            handleDeleteEntryInfluence(options?.influenceId)
                        }
                    }
                    if (options?.outcomeId) {
                        handleDeleteEntry(options?.outcomeId)
                    }
                    setVisibleFullStepper(true)
                    setIsInFullView(true)
                }} style={!expandedLevelView ? {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                } : {}}>
                    {expandedLevelView ? (
                        <div className={expandedLevelView ? classes.rectangleInputFull : classes.rectangleInput} style={expandedLevelView ? {} : {
                            background: isDarkMode ? 'transparent' : '#DCE5E0'
                        }}

                        >
                            <div className={classes.rectangleInput} style={{
                                background: options.absenceToggle && !itemObject?.index ? "#DCE5E0" : itemObject?.nearValue ? itemObject?.nearValue : isDarkMode ? 'transparent' : '#DCE5E0'  // 
                            }}
                            >
                                <Typography className={classes.counterView} sx={{
                                    color: isDarkMode ? 'var(--dark-surface) !important' : 'var(--color-text-primary) !important',
                                    textAlign: 'center !important',
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    lineHeight: '100%',
                                    transform: 'rotate(90deg)',
                                    "@media  (max-width: 726px) and (min-width: 100px)": {
                                        fontSize: `14px !important`,
                                        lineHeight: `16.8px !important`,
                                    },
                                }}>
                                      {options.absenceToggle && !itemObject?.index ? 0 : itemObject?.index}
                                </Typography>
                            </div>
                            <Typography className={classes.counterView} sx={{
                                color: 'var(--color-text-primary) !important',
                                textAlign: 'left !important',
                                fontSize: '16px',
                                fontWeight: 600,
                                lineHeight: '135% !important', /* 16px */
                                "&.MuiTypography-root": {
                                    "@media  (max-width: 726px) and (min-width: 100px)": {
                                        fontSize: `14px !important`,
                                        lineHeight: `16.8px !important`,
                                    },
                                }
                            }}>
                                {options.absenceToggle && !itemObject?.index ? "Absence" : ([...optionsData].reverse()[options.absenceToggle ? itemObject?.index : itemObject?.index - 1] && [...optionsData].reverse()[options.absenceToggle ? itemObject?.index : itemObject?.index - 1]?.text ? [...optionsData].reverse()[options.absenceToggle ? itemObject?.index : itemObject?.index - 1]?.text : "") || ''}
                            </Typography>
                        </div>
                    ) : (
                        <div className={classes.rectangleInput} style={{
                            background: options.absenceToggle && !itemObject?.index ? "#DCE5E0" : itemObject?.nearValue ? itemObject?.nearValue : (isDarkMode ? 'transparent' : '#DCE5E0')  // 
                        }}
                        >
                            <Typography className={classes.counterView} sx={{
                                color: isDarkMode ? 'var(--dark-surface) !important' : 'var(--color-text-primary) !important',
                                textAlign: 'center !important',
                                fontSize: '14px',
                                fontWeight: 600,
                                lineHeight: '100%', /* 16px */
                                transform: 'rotate(90deg)',
                                "@media  (max-width: 726px) and (min-width: 100px)": {
                                    fontSize: `14px !important`,
                                    lineHeight: `16.8px !important`,
                                },
                            }}>
                                {options.absenceToggle && !itemObject?.index ? 0 : itemObject?.index}
                            </Typography>
                        </div>
                    )}


                </div>
            ) : (
                <div className={expandedLevelView ? classes.selectionExpanded : classes.selection}>
                    {expandedLevelView ? (
                        <>
                            <Box display={"flex"} alignItems={"center"} flexDirection={"column"} width={"100%"} gap={'7px'}>
                                {optionsData.map((it, index) => checkAndReturnFullView(index) && (
                                    <div className={expandedLevelView ? classes.rectangleInputFull : classes.rectangleInput} style={expandedLevelView ? {} : {
                                        background: isDarkMode ? 'transparent' : '#DCE5E0'
                                    }}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            if (options.influenceId) {
                                                const create = () => {
                                                    createInfluence(itemObject?.index > -1, it.score || null, it.score, itemObject?.note, options.absenceToggle ? optionsData.length - index - 1 : optionsData.length - index, options.type)
                                                    setVisibleFullStepper(false)
                                                }
                                                if (options.absenceToggle) {
                                                    if (optionsData.length - index - 1 === itemObject?.index) {
                                                        handleDeleteEntryInfluence(options?.influenceId)
                                                    } else {
                                                        create()
                                                    }
                                                } else if (!options.absenceToggle) {
                                                    if (optionsData.length - index === itemObject?.index) {
                                                        handleDeleteEntry(options?.influenceId)
                                                    } else {
                                                        create()
                                                    }
                                                }
                                            }
                                            if (options?.outcomeId) {
                                                const create = () => {
                                                    createOutcome(itemObject?.index > -1, it.score || null, it.score, itemObject?.note, options.absenceToggle ? optionsData.length - index - 1 : optionsData.length - index)
                                                    setVisibleFullStepper(false)
                                                }
                                                if (options.absenceToggle) {
                                                    if (optionsData.length - index - 1 === itemObject?.index) {
                                                        handleDeleteEntry(options?.outcomeId)
                                                    } else {
                                                        create()
                                                    }
                                                } else if (!options.absenceToggle) {
                                                    if (optionsData.length - index === itemObject?.index) {
                                                        handleDeleteEntry(options?.outcomeId)
                                                    } else {
                                                        create()
                                                    }
                                                }
                                            }
                                        }}
                                    >
                                        {options.absenceToggle ? itemObject?.index === (optionsData.length - index - 1) && tickMark : itemObject?.index === ((optionsData.length - index)) && tickMark}
                                        <div className={classes.rectangleInput} style={{
                                            background: options.absenceToggle ? itemObject?.index === (optionsData.length - index - 1) ? it.colorCode :(isDarkMode ? "transparent" : '#DCE5E0') : itemObject?.index === ((optionsData.length - index)) ? it.colorCode : isDarkMode ? 'transparent' : '#DCE5E0'  // 
                                        }}
                                        >
                                            <Typography className={classes.counterView} sx={{
                                                color: (options.absenceToggle && itemObject?.index === (optionsData.length - index - 1)) || (!options.absenceToggle && itemObject?.index === ((optionsData.length - index))) ? 'var(--color-text-primary) !important' : "var(--color-text-secondary) !important",
                                                textAlign: 'center !important',
                                                fontSize: '16px',
                                                fontWeight: (options.absenceToggle && itemObject?.index === (optionsData.length - index - 1)) || (!options.absenceToggle && itemObject?.index === ((optionsData.length - index))) ? 600 : 400,
                                                lineHeight: '100%', /* 16px */
                                                transform: 'rotate(90deg)',
                                                "@media  (max-width: 726px) and (min-width: 100px)": {
                                                    fontSize: `14px !important`,
                                                    lineHeight: `16.8px !important`,
                                                },
                                            }}>
                                                {options.absenceToggle ? optionsData.length - index - 1 : optionsData.length - index}
                                            </Typography>
                                        </div>
                                        <Typography className={classes.counterView} sx={{
                                            color: (options.absenceToggle && itemObject?.index === (optionsData.length - index - 1)) || (!options.absenceToggle && itemObject?.index === ((optionsData.length - index))) ? 'var(--color-text-primary) !important' : "var(--color-text-secondary) !important",
                                            textAlign: 'left !important',
                                            fontSize: '16px',
                                            fontWeight: (options.absenceToggle && itemObject?.index === (optionsData.length - index - 1)) || (!options.absenceToggle && itemObject?.index === (optionsData.length - index)) ? 600 : 400,
                                            lineHeight: '135% !important', /* 16px */
                                            "&.MuiTypography-root": {
                                                "@media  (max-width: 726px) and (min-width: 100px)": {
                                                    fontSize: `14px !important`,
                                                    lineHeight: `16.8px !important`,
                                                },
                                            }
                                        }}>
                                            {it.text || ''}
                                        </Typography>
                                    </div>
                                ))}
                            </Box>
                            {!isInFullView && Number(itemObject?.index) > -1 && (
                                <div onClick={(e) => {
                                    e.stopPropagation()
                                    setIsInFullView(true)
                                }}>
                                    {/* <EditIcon /> */}
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.3838 3.40881L10.5913 0.615685C10.4752 0.499558 10.3374 0.407439 10.1857 0.344589C10.034 0.281739 9.87139 0.24939 9.70719 0.24939C9.543 0.24939 9.38041 0.281739 9.22872 0.344589C9.07703 0.407439 8.93921 0.499558 8.82313 0.615685L1.11626 8.32318C0.999757 8.43892 0.907394 8.57663 0.844523 8.72834C0.781653 8.88004 0.749526 9.04272 0.750005 9.20693V12.0001C0.750005 12.3316 0.881701 12.6495 1.11612 12.8839C1.35054 13.1184 1.66848 13.2501 2.00001 13.2501H4.79313C4.95734 13.2505 5.12001 13.2184 5.27171 13.1555C5.42341 13.0926 5.56112 13.0003 5.67688 12.8838L13.3838 5.17631C13.6181 4.9419 13.7497 4.62402 13.7497 4.29256C13.7497 3.9611 13.6181 3.64322 13.3838 3.40881ZM4.68751 11.7501H2.25001V9.31256L7.50001 4.06256L9.93751 6.50006L4.68751 11.7501ZM11 5.43756L8.56251 3.00006L9.70876 1.85381L12.1463 4.29131L11 5.43756Z" fill="#656565" />
                                    </svg>
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            {optionsData.map((it, index) => (
                                <div className={classes.rectangleInput} style={{
                                    background: options.absenceToggle ? Number(itemObject?.index) === parseInt(index) ? it.colorCode : (isDarkMode ? "transparent" : '#DCE5E0') : Number(itemObject?.index) === (parseInt(index) + 1) ? it.colorCode : outcomeState.isDarkMode ? 'transparent' : isDarkMode ? 'transparent' : '#DCE5E0'  // 
                                }}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        if (options.influenceId) {
                                            if ((options.absenceToggle && itemObject?.index === parseInt(index)) || itemObject?.index === (parseInt(index) + 1)) {
                                                handleDeleteEntryInfluence(options.influenceId)
                                            } else {
                                                createInfluence(itemObject?.index > -1, it.score || null, it.score, itemObject?.note, options.absenceToggle ? parseInt(index) : (parseInt(index) + 1), options.type)
                                                setVisibleFullStepper(false)
                                            }
                                        }
                                        if (options?.outcomeId) {
                                            if ((options.absenceToggle && itemObject?.index === parseInt(index)) || itemObject?.index === (parseInt(index) + 1)) {
                                                handleDeleteEntry(options?.outcomeId)
                                            } else {
                                                createOutcome(itemObject?.index > -1, it.score || null, it.score, itemObject?.note, options.absenceToggle ? parseInt(index) : (parseInt(index) + 1))
                                                setVisibleFullStepper(false)
                                            }
                                        }
                                    }}
                                >
                                    {options.absenceToggle ? Number(itemObject?.index) === parseInt(index) && tickMark : Number(itemObject?.index) === (parseInt(index) + 1) && tickMark}
                                    <Typography className={classes.counterView} sx={{
                                        color: (options.absenceToggle && itemObject?.index === parseInt(index)) || itemObject?.index === (parseInt(index) + 1) ? 'var(--color-text-primary) !important' : "var(--color-text-secondary) !important",
                                        textAlign: 'center !important',
                                        fontSize: '16px',
                                        fontWeight: 500,
                                        lineHeight: '100%', /* 16px */
                                        transform: 'rotate(90deg)',
                                        "@media  (max-width: 726px) and (min-width: 100px)": {
                                            fontSize: `14px !important`,
                                            lineHeight: `16.8px !important`,
                                        },
                                    }}>
                                        {options.absenceToggle ? index : index + 1}
                                    </Typography>
                                </div>
                            ))}
                        </>
                    )}
                </div>
            )}

        </>
    }
    let showNewView = props?.type === "outcome" || ((props?.item?.type === "TYPE2") && (
        props?.item?.unitValue !== "timeofday" &&
        props?.item?.metric_type !== "NEUTRAL"
    )) ? true : false
    const classNaaame = showNewView ? classes.cardBodyNew : classes.cardBody
    const iconisDefault = props?.item?.icon === fixOutcomeIcon[0].path
    let foundIcon = foundSelectedIcon(props?.item?.icon)
    const redBackground = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
    return (
        <div className={classNaaame} key={props?.index + '_' + props.headerDate} onClick={() => {
            if (clickCondition && !props?.item?.lockMatrix) {
                props?.setItem(props?.item);
                if (props?.type === "outcome") {
                    setShowInput(false);
                    props?.setOpenTrackingEventModal(true);
                    props?.setDisplayBorder(true);
                    props?.setItem(props?.item);
                    props?.setOutcomeId(props?.item?._id);
                    props?.setSelectedOption(parseInt(props?.optionIndex + 1));
                    let i = outcomeState.outcomeList.findIndex(
                        (outcome) => outcome._id === props?.item?._id
                    );
                    props?.setOutcomeIndex(i);
                } else if (props?.type === "influence") {
                    if (
                        (clickCondition && props?.item?.type === "TYPE3") ||
                        (clickCondition &&
                            props?.item?.type === "TYPE1" &&
                            props?.item?.flag === "yes")
                    ) {
                        props?.setOpenYesNoModal(true);
                        props.setInfluenceId(props?.item._id);
                        return
                    }
                    if (
                        clickCondition &&
                        props?.item?.type === "TYPE12" &&
                        props?.item?.unitValue === "timeofday" &&
                        props?.item?.metric_type === "NEUTRAL"
                    ) {
                        props?.setOpenTimeOfDayModal(true);
                        // props?.setCategoryId(props?.category?.categoryId)
                        props.setInfluenceId(props?.item._id);
                        return
                    } else if (
                        clickCondition &&
                        props?.item?.type === "TYPE12" &&
                        props?.item?.flag === "no"
                    ) {
                        setShowInput(false);
                        props?.setOpenHoursModal(true);
                        props?.setInfluenceId(props?.item._id);
                        props?.setItem(props?.item);
                    }
                    if (showNewView) {
                        setShowInput(false);
                        props?.setOpenTrackingEventModal(true);
                        props?.setDisplayBorder(true);
                        props.setInfluenceId(props?.item._id);
                        props?.setItem(props?.item);
                        props?.setSelectedOption(parseInt(props?.optionIndex + 1));
                        let i = outcomeState.influenceList.findIndex(
                            (influence) => influence._id === props?.item?._id
                        );
                        props?.setOutcomeIndex(i);
                    }
                    if (!showNewView) {
                        setShowInput(true);
                    }
                    setNoData(false);
                    props.setInfluenceId(props?.item._id);
                } else {
                    if (!showDescriptionInput) {
                        props?.setRefId(props?.item.reflectiveId);
                        props?.setOpenRefQuesModal(true);
                    }
                }
            }
        }} onDoubleClick={() => {
            setNoData(true);
            if (props?.type === "outcome") {
                if (clickCondition && !props?.item?.lockMatrix) {
                    setShowInput(false);
                    props?.setOpenTrackingEventModal(true);
                    props?.setDisplayBorder(true);
                    props?.setItem(props?.item);
                    props?.setOutcomeId(props?.item?._id);
                    props?.setSelectedOption(parseInt(props?.optionIndex + 1));
                    let i = outcomeState.outcomeList.findIndex(
                        (outcome) => outcome._id === props?.outcomeId
                    );
                    props?.setOutcomeIndex(i);
                }
            } else if (props?.type == "influence") {
                if (clickCondition && props?.item?.type === "TYPE2" && !props?.item?.lockMatrix) {
                    setShowInput(false);
                    props?.setOpenTrackingEventModal(true);
                    props?.setDisplayBorder(true);
                    props.setInfluenceId(props?.item._id);
                    props?.setItem(props?.item);
                    props?.setSelectedOption(parseInt(props?.optionIndex + 1));
                    let i = outcomeState.influenceList.findIndex(
                        (influence) => influence._id === props?.influenceId
                    );
                    props?.setOutcomeIndex(i);
                } else if (
                    ((clickCondition && props?.item?.type === "TYPE3") ||
                        (clickCondition &&
                            props?.item?.type === "TYPE1" &&
                            props?.item?.flag === "yes")) && !props?.item?.lockMatrix
                ) {
                    props?.setOpenYesNoModal(true);
                } else if (
                    clickCondition &&
                    props?.item?.type === "TYPE12" &&
                    props?.item?.flag === "no" && !props?.item?.lockMatrix
                ) {
                    setShowInput(false);
                    props?.setOpenHoursModal(true);
                    props?.setInfluenceId(props?.item._id);
                    props?.setItem(props?.item);
                }
            }
        }} style={{
            position: "relative"
        }}>

            <div style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "16px"
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "8px"
                }}>
                    {(props?.item?.icon && props?.item?.icon.length > 50) &&
                        !foundIcon ? (
                        <SvgIcon color="action" fontSize="small" width={"16px"} height={"16px"} sx={iconisDefault ? {
                            verticalAlign: "middle", width: "16px !important",
                            height: "16px !important",
                            fontSize: "16px", // Ensures consistent size
                        } : {
                            width: "16px !important",
                            height: "16px !important",
                            fontSize: "16px", // Ensures consistent size
                        }}>
                            <path d={props?.item?.icon} fill={iconisDefault ? "var(--color-new-main)" : ""} />
                        </SvgIcon>
                    ) : props?.item?.icon && props?.item?.iconType ? (
                        props?.item?.iconType === ICON_SLECTIN_TABS.EMOJI ? <span style={{
                            height: "16px",
                            width: "16px",
                            fontSize: "16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}>{props?.item?.icon}</span> :
                            props?.item?.iconType === ICON_SLECTIN_TABS.ICON ? <FontAwesomeIconRender selectedIcon={props?.item?.icon} style={{
                                height: "16px",
                                width: "16px",
                            }} /> :
                                props?.item?.iconType === ICON_SLECTIN_TABS.IMAGE ? <img
                                    alt="toggl"
                                    width="16px" height="16px"
                                    src={
                                        props?.item?.icon
                                            ? `${baseEndpoints.getImage}${props?.item?.icon}`
                                            : "/toggl.png"
                                    }
                                    style={{
                                        height: "16px",
                                        width: "16px",
                                        borderRadius: "10px"
                                    }}
                                /> : null
                    ) : null}
                    <CommonTypo color="var(--color-text-primary)" fontWeight={600} size={14} lineHeight={16.8} extraSx={{
                        wordBreak: "break-all"
                    }}>{props?.title}</CommonTypo>
                </div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexShrink: 0,
                    }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                >
                    {outcomeState?.isPersonal &&
                        props?.category &&
                        props?.category?.name !== "Other" &&
                        (props?.item?.outcomeId ||
                            props?.item?.influenceId ||
                            props?.item?.reflectiveId ||
                            props?.item?._id) ? (
                        <MoveMetricPopover
                            sourceCategoryId={String(
                                props?.category?.categoryId ?? props?.category?._id
                            )}
                            metricType={
                                props?.type === "influence"
                                    ? "influence"
                                    : props?.type === "reflective"
                                        ? "reflective"
                                        : "outcome"
                            }
                            metricId={String(
                                props?.type === "influence"
                                    ? props?.item?.influenceId || props?.item?._id
                                    : props?.type === "reflective"
                                        ? props?.item?.reflectiveId || props?.item?._id
                                        : props?.item?.outcomeId || props?.item?._id
                            )}
                            journeyCategoryList={outcomeState?.journeyCategoryList || []}
                            token={outcomeState?.token}
                            restricted={outcomeState?.restrictUser}
                            onRestricted={() =>
                                UserTypeDispatch(setOpenSubscriptionModal(true))
                            }
                            callservice={props?.callService}
                            trackingDispatch={props?.trackingDispatch}
                            iconSx={{
                                fontSize: "16px",
                                width: "16px",
                                height: "16px",
                                color: isDarkMode
                                    ? "var(--color-text-secondary)"
                                    : "#656565",
                            }}
                        />
                    ) : null}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (props?.type === "outcome") {
                                props?.setAddOutcomeTracking(true);
                                props?.setStartModal(true);
                                props?.setOutcomeValue(props?.item);
                            }
                            if (props?.type === "influence") {
                                props?.setAddInfluenceTracking(true);
                                props?.setStartModalInfluence(true);
                                props?.setInfluenceData(props?.item);
                            }
                            if (props?.type === "reflective") {
                                props?.setAddQuesTracking(true);
                                props?.setStartModalQues(true);
                                props?.setQuestionData(props?.item);
                            }
                        }}
                    >
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.3838 3.40881L10.5913 0.615685C10.4752 0.499558 10.3374 0.407439 10.1857 0.344589C10.034 0.281739 9.87139 0.24939 9.70719 0.24939C9.543 0.24939 9.38041 0.281739 9.22872 0.344589C9.07703 0.407439 8.93921 0.499558 8.82313 0.615685L1.11626 8.32318C0.999757 8.43892 0.907394 8.57663 0.844523 8.72834C0.781653 8.88004 0.749526 9.04272 0.750005 9.20693V12.0001C0.750005 12.3316 0.881701 12.6495 1.11612 12.8839C1.35054 13.1184 1.66848 13.2501 2.00001 13.2501H4.79313C4.95734 13.2505 5.12001 13.2184 5.27171 13.1555C5.42341 13.0926 5.56112 13.0003 5.67688 12.8838L13.3838 5.17631C13.6181 4.9419 13.7497 4.62402 13.7497 4.29256C13.7497 3.9611 13.6181 3.64322 13.3838 3.40881ZM4.68751 11.7501H2.25001V9.31256L7.50001 4.06256L9.93751 6.50006L4.68751 11.7501ZM11 5.43756L8.56251 3.00006L9.70876 1.85381L12.1463 4.29131L11 5.43756Z" fill={isDarkMode ? "var(--color-text-secondary)" : "#656565"} />
                        </svg>
                    </div>
                </div>
                {/* <img src={LineGraph} className={classes.lineGraph} /> */}
            </div>
            <div
                className={(props?.item?.type === "TYPE3") ||
                    (
                        props?.item?.type === "TYPE1" &&
                        props?.item?.flag === "yes") ? "" : showNewView ? classes.inputContainerFullWidth : classes.inputContainer}

                key={props.headerDate}
                style={foundData ? props.type === "reflective" ? {
                    height: "auto",
                    borderColor: "transparent"
                } : {
                    borderColor: "transparent"
                } : {}}
                id={`${props.headerDate}`}
            >
                {showInput || (props?.type === "reflective" && showDescriptionInput) ? props?.type === "reflective" && showDescriptionInput ? (
                    <Box display={"flex"} alignItems={"center"} gap={"8px"} width={"100%"} >

                        <textarea
                            name={props?.item?._id}
                            autoFocus
                            ref={textareaRef}
                            value={inputNotesValue}
                            style={{
                                width: "95%",
                                minHeight: "10px",
                                resize: "none",
                                outline: "none",
                                border: "none"
                            }}
                            onBlur={() => {
                                // let journey = {}
                                // if (props?.type === "outcome") {
                                //     journey = journeyDataOutcome.find(it => it?.outcomeId === props?.item?.outcomeId &&
                                //         it?.date === props.headerDate)
                                // }
                                // if (props?.type === "influence") {
                                //     journey = journeyDataInfluence.find(it => it?.influenceId === props?.item?.influenceId &&
                                //         it?.date === props.headerDate)
                                // }
                                // if (props?.type === "reflective") {
                                //     journey = journeyDataReflective.find(it => it?.reflectiveId === props?.item?.reflectiveId &&
                                //         it?.date === props.headerDate)
                                // }
                                // handleBlurInputAreaInfluence(
                                //     props?.item?.type,
                                //     { key: "kdksjdks", keyCode: "hdj" },
                                //     true,
                                //     journey
                                // );
                            }}
                            onChange={(e) => {
                                setNotesInputValue(e.target.value);
                            }}
                            onKeyDown={(e) => {
                                let journey = {}
                                if (props?.type === "outcome") {
                                    journey = journeyDataOutcome.find(it => it?.outcomeId === props?.item?.outcomeId &&
                                        it?.date === props.headerDate)
                                }
                                if (props?.type === "influence") {
                                    journey = journeyDataInfluence.find(it => it?.influenceId === props?.item?.influenceId &&
                                        it?.date === props.headerDate)
                                }
                                if (props?.type === "reflective") {
                                    journey = journeyDataReflective.find(it => it?.reflectiveId === props?.item?.reflectiveId &&
                                        it?.date === props.headerDate)
                                }
                                handleBlurInputAreaInfluence(
                                    props?.item?.type,
                                    e,
                                    false,
                                    journey
                                );
                            }}
                        />
                        <Button variant="contained" sx={{
                            width: "32px !important",
                            minWidth: "32px !important",
                            height: "18px !important",
                            minHeight: "18px !important",
                            padding: "2px 8px",
                            gap: "8px",
                            borderRadius: "6px",
                            background: "var(--color-new-main)",
                            boxShadow: "none",
                            marginBottom: "0px !important",
                            "&:hover": {
                                background: "var(--color-new-main)",
                                boxShadow: "none",
                            },
                            "&::after": {
                                width: "0px"
                            }
                        }} onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            let journey = {}
                            if (props?.type === "outcome") {
                                journey = journeyDataOutcome.find(it => it?.outcomeId === props?.item?.outcomeId &&
                                    it?.date === props.headerDate)
                            }
                            if (props?.type === "influence") {
                                journey = journeyDataInfluence.find(it => it?.influenceId === props?.item?.influenceId &&
                                    it?.date === props.headerDate)
                            }
                            if (props?.type === "reflective") {
                                journey = journeyDataReflective.find(it => it?.reflectiveId === props?.item?.reflectiveId &&
                                    it?.date === props.headerDate)
                            }
                            handleBlurInputAreaInfluence(
                                props?.item?.type,
                                { key: "kdksjdks", keyCode: "hdj" },
                                true,
                                journey
                            );
                        }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.1633 5.7454L7.01129 12.4809C6.95771 12.5398 6.89404 12.5865 6.82393 12.6183C6.75383 12.6502 6.67867 12.6666 6.60276 12.6666C6.52685 12.6666 6.45169 12.6502 6.38158 12.6183C6.31148 12.5865 6.24781 12.5398 6.19423 12.4809L3.50272 9.53412C3.44907 9.47538 3.40651 9.40565 3.37747 9.32891C3.34844 9.25216 3.3335 9.16991 3.3335 9.08684C3.3335 9.00377 3.34844 8.92152 3.37747 8.84477C3.40651 8.76803 3.44907 8.6983 3.50272 8.63956C3.55637 8.58082 3.62006 8.53423 3.69015 8.50244C3.76025 8.47065 3.83538 8.45429 3.91125 8.45429C3.98712 8.45429 4.06225 8.47065 4.13235 8.50244C4.20244 8.53423 4.26613 8.58082 4.31978 8.63956L6.60324 11.1396L12.3472 4.8519C12.4556 4.73327 12.6025 4.66663 12.7557 4.66663C12.909 4.66663 13.0559 4.73327 13.1643 4.8519C13.2726 4.97052 13.3335 5.13141 13.3335 5.29917C13.3335 5.46694 13.2726 5.62783 13.1643 5.74645L13.1633 5.7454Z" fill="#292B2A" />
                            </svg>
                        </Button>
                    </Box>
                ) : (
                    <input
                        className={classes.rateInput}
                        autoFocus
                        onChange={(e) => {
                            setInputValue(e.target.value);
                        }}
                        onBlur={() => {
                            props?.type === "outcome"
                                ? handleBlurInput(
                                    props?.item?._id,
                                    props?.index,
                                    props.headerDate,
                                    { key: "kdksjdks", keyCode: "hdj" },
                                    true
                                )
                                : handleBlurInputInfluence(props?.item?.type, { key: "kdksjdks", keyCode: "hdj" }, true)
                        }}
                        onKeyDown={(e) =>
                            props?.type === "outcome"
                                ? handleBlurInput(
                                    props?.item?._id,
                                    props?.index,
                                    props.headerDate,
                                    e,
                                    false
                                )
                                : handleBlurInputInfluence(props?.item?.type, e, false)
                        }

                    />
                ) : foundData && (
                    <>
                        {journeyDataOutcome?.map((journey, index) => {
                            if (
                                journey?.outcomeId === props?.item?.outcomeId &&
                                journey?.date === props.headerDate
                            ) {
                                let nearValue = nearestValueOutcome(journey?.index, journey)

                                if (journey?.type === "TYPE2") {
                                    nearValue = null
                                }
                                if (props?.item?.outcomeId && props?.item?.options?.length && props?.item?.options[journey?.index - 1]) {
                                    nearValue = props.item.options[journey?.index - 1].colorCode
                                }
                                if (Number(journey?.score) === 0) {
                                    nearValue = '#C7C7C7'
                                }
                                return levelRender({
                                    ...journey,
                                    nearValue
                                }, props?.item)
                            }
                        })}
                        {journeyDataInfluence?.map((journey: any, index: number) => {
                            if (
                                journey?.influenceId === props?.item?.influenceId &&
                                journey?.date === props.headerDate
                            ) {
                                noData = false
                                NoData && setNoData(false);
                                let nearValue = nearestValue(
                                    journey?.type === "TYPE1" ||
                                        journey?.type === "TYPE12"
                                        ? journey?.score
                                        : journey?.index, props?.item)
                                if (journey?.type === "TYPE2") {
                                    if (props?.item?.type === "TYPE2" && props?.item.options.length && props?.item.options[journey?.index - 1]) {
                                        nearValue = props?.item.options[journey?.index - 1].colorCode
                                    }
                                }
                                if ((props?.item?.type === "TYPE3") ||
                                    (
                                        props?.item?.type === "TYPE1" &&
                                        props?.item?.flag === "yes")) {
                                    if (!journey?.levelReach || !visibleYesnotSwitch) {
                                        if (journey?.inverse === "true") {
                                            if (journey?.levelReach === "No") {
                                                return <div onClick={(e) => {
                                                    e.stopPropagation()
                                                    handleDeleteEntryInfluence(props?.item?.influenceId)
                                                    setVisibleSwitch(true)
                                                }} style={{
                                                    height: "40px",
                                                    ...redBackground
                                                }}>
                                                    <div className={clsx(classes.backgroundYesNo, classes.corssActiveInverse)} style={{
                                                        width: "144px",
                                                        alignSelf: "center",
                                                        justifySelf: "center"
                                                    }}>
                                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M13.5306 11.9694C13.6715 12.1103 13.7506 12.3014 13.7506 12.5006C13.7506 12.6999 13.6715 12.891 13.5306 13.0319C13.3897 13.1728 13.1986 13.2519 12.9993 13.2519C12.8001 13.2519 12.609 13.1728 12.4681 13.0319L8.49997 9.06249L4.5306 13.0306C4.3897 13.1715 4.19861 13.2507 3.99935 13.2507C3.80009 13.2507 3.60899 13.1715 3.4681 13.0306C3.3272 12.8897 3.24805 12.6986 3.24805 12.4994C3.24805 12.3001 3.3272 12.109 3.4681 11.9681L7.43747 7.99999L3.46935 4.03061C3.32845 3.88972 3.2493 3.69862 3.2493 3.49936C3.2493 3.30011 3.32845 3.10901 3.46935 2.96811C3.61024 2.82722 3.80134 2.74806 4.0006 2.74806C4.19986 2.74806 4.39095 2.82722 4.53185 2.96811L8.49997 6.93749L12.4693 2.96749C12.6102 2.82659 12.8013 2.74744 13.0006 2.74744C13.1999 2.74744 13.3909 2.82659 13.5318 2.96749C13.6727 3.10838 13.7519 3.29948 13.7519 3.49874C13.7519 3.69799 13.6727 3.88909 13.5318 4.02999L9.56247 7.99999L13.5306 11.9694Z" fill="var(--color-text-primary)" />
                                                        </svg>
                                                        <CommonTypo fontWeight={600} color="var(--color-text-primary)" size={14} lineHeight={18.2}>No</CommonTypo>
                                                    </div>
                                                </div>
                                            }
                                            if (journey?.levelReach === "Yes") {
                                                return <div onClick={(e) => {
                                                    e.stopPropagation()
                                                    handleDeleteEntryInfluence(props?.item?.influenceId)
                                                    setVisibleSwitch(true)
                                                }} style={{
                                                    height: "40px",
                                                    ...redBackground
                                                }}>
                                                    <div className={clsx(classes.backgroundYesNo, classes.rightActiveInverse)} style={{
                                                        width: "144px",
                                                        alignSelf: "center",
                                                        justifySelf: "center"
                                                    }}>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M14.5306 5.03057L6.5306 13.0306C6.46092 13.1005 6.37813 13.156 6.28696 13.1938C6.1958 13.2317 6.09806 13.2512 5.99935 13.2512C5.90064 13.2512 5.8029 13.2317 5.71173 13.1938C5.62057 13.156 5.53778 13.1005 5.4681 13.0306L1.9681 9.53057C1.89833 9.4608 1.84299 9.37798 1.80524 9.28683C1.76748 9.19568 1.74805 9.09798 1.74805 8.99932C1.74805 8.90066 1.76748 8.80296 1.80524 8.71181C1.84299 8.62066 1.89833 8.53783 1.9681 8.46807C2.03786 8.3983 2.12069 8.34296 2.21184 8.30521C2.30299 8.26745 2.40069 8.24802 2.49935 8.24802C2.59801 8.24802 2.69571 8.26745 2.78686 8.30521C2.87801 8.34296 2.96083 8.3983 3.0306 8.46807L5.99997 11.4374L13.4693 3.96932C13.6102 3.82842 13.8013 3.74927 14.0006 3.74927C14.1999 3.74927 14.391 3.82842 14.5318 3.96932C14.6727 4.11021 14.7519 4.30131 14.7519 4.50057C14.7519 4.69983 14.6727 4.89092 14.5318 5.03182L14.5306 5.03057Z" fill="var(--color-text-primary)" />
                                                        </svg>
                                                        <CommonTypo fontWeight={600} color="var(--color-text-primary)" size={14} lineHeight={18.2}>Yes</CommonTypo>
                                                    </div>
                                                </div>
                                            }
                                        } else {
                                            if (journey?.levelReach === "Yes") {
                                                return <div onClick={(e) => {
                                                    e.stopPropagation()
                                                    handleDeleteEntryInfluence(props?.item?.influenceId)
                                                    setVisibleSwitch(true)
                                                }} style={{
                                                    height: "40px",
                                                    ...redBackground
                                                }}>
                                                    <div className={clsx(classes.backgroundYesNo, classes.rightActive)} style={{
                                                        width: "144px",
                                                        alignSelf: "center",
                                                        justifySelf: "center"
                                                    }}>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M14.5306 5.03057L6.5306 13.0306C6.46092 13.1005 6.37813 13.156 6.28696 13.1938C6.1958 13.2317 6.09806 13.2512 5.99935 13.2512C5.90064 13.2512 5.8029 13.2317 5.71173 13.1938C5.62057 13.156 5.53778 13.1005 5.4681 13.0306L1.9681 9.53057C1.89833 9.4608 1.84299 9.37798 1.80524 9.28683C1.76748 9.19568 1.74805 9.09798 1.74805 8.99932C1.74805 8.90066 1.76748 8.80296 1.80524 8.71181C1.84299 8.62066 1.89833 8.53783 1.9681 8.46807C2.03786 8.3983 2.12069 8.34296 2.21184 8.30521C2.30299 8.26745 2.40069 8.24802 2.49935 8.24802C2.59801 8.24802 2.69571 8.26745 2.78686 8.30521C2.87801 8.34296 2.96083 8.3983 3.0306 8.46807L5.99997 11.4374L13.4693 3.96932C13.6102 3.82842 13.8013 3.74927 14.0006 3.74927C14.1999 3.74927 14.391 3.82842 14.5318 3.96932C14.6727 4.11021 14.7519 4.30131 14.7519 4.50057C14.7519 4.69983 14.6727 4.89092 14.5318 5.03182L14.5306 5.03057Z" fill="var(--color-text-primary)" />
                                                        </svg>
                                                        <CommonTypo fontWeight={600} color="var(--color-text-primary)" size={14} lineHeight={18.2}>Yes</CommonTypo>
                                                    </div>
                                                </div>
                                            }
                                            if (journey?.levelReach === "No") {
                                                return <div onClick={(e) => {
                                                    e.stopPropagation()
                                                    handleDeleteEntryInfluence(props?.item?.influenceId)
                                                    setVisibleSwitch(true)
                                                }} style={{
                                                    height: "40px",
                                                    ...redBackground
                                                }}>
                                                    <div className={clsx(classes.backgroundYesNo, classes.corssActive)} style={{
                                                        width: "144px",
                                                        alignSelf: "center",
                                                        justifySelf: "center"
                                                    }}>
                                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M13.5306 11.9694C13.6715 12.1103 13.7506 12.3014 13.7506 12.5006C13.7506 12.6999 13.6715 12.891 13.5306 13.0319C13.3897 13.1728 13.1986 13.2519 12.9993 13.2519C12.8001 13.2519 12.609 13.1728 12.4681 13.0319L8.49997 9.06249L4.5306 13.0306C4.3897 13.1715 4.19861 13.2507 3.99935 13.2507C3.80009 13.2507 3.60899 13.1715 3.4681 13.0306C3.3272 12.8897 3.24805 12.6986 3.24805 12.4994C3.24805 12.3001 3.3272 12.109 3.4681 11.9681L7.43747 7.99999L3.46935 4.03061C3.32845 3.88972 3.2493 3.69862 3.2493 3.49936C3.2493 3.30011 3.32845 3.10901 3.46935 2.96811C3.61024 2.82722 3.80134 2.74806 4.0006 2.74806C4.19986 2.74806 4.39095 2.82722 4.53185 2.96811L8.49997 6.93749L12.4693 2.96749C12.6102 2.82659 12.8013 2.74744 13.0006 2.74744C13.1999 2.74744 13.3909 2.82659 13.5318 2.96749C13.6727 3.10838 13.7519 3.29948 13.7519 3.49874C13.7519 3.69799 13.6727 3.88909 13.5318 4.02999L9.56247 7.99999L13.5306 11.9694Z" fill="var(--color-text-primary)" />
                                                        </svg>
                                                        <CommonTypo fontWeight={600} color="var(--color-text-primary)" size={14} lineHeight={18.2}>No</CommonTypo>
                                                    </div>
                                                </div>
                                            }
                                        }

                                    }
                                    return <IconYesNo2 matricValue={journey} journalItem={props?.item} onClick={createInfluenceLevel} onDelete={() => handleDeleteEntryInfluence(props?.item?.influenceId)} />
                                }
                                if (Number(journey?.score) === 0 && journey?.type === "TYPE2") {
                                    nearValue = '#C7C7C7'
                                }
                                if (showNewView) {
                                    return levelRender({
                                        ...journey,
                                        nearValue
                                    }, props?.item)
                                }
                                let fontStyling = {

                                }
                                if (journey?.type === "TYPE1" || journey?.type === "TYPE12") {
                                    if (journey?.score && journey?.score?.toString()?.length === 2) {
                                        fontStyling = {
                                            fontSize: "14px"
                                        }
                                    }
                                    if (journey?.score?.toString()?.length >= 3) {
                                        fontStyling = {
                                            fontSize: "12px"
                                        }
                                    }
                                }
                                return (
                                    <div
                                        key={index}
                                        style={{ width: journey?.timeOfDay ? "68px" : props?.item?.type === "TYPE12" ? "40px" : "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
                                        onClick={(e) => {
                                            if (
                                                clickCondition &&
                                                props?.item?.type === "TYPE12" &&
                                                props?.item?.flag === "no" &&
                                                !props?.item?.lockMatrix &&
                                                props?.item?.unitValue !== "timeofday"
                                            ) {
                                                e.stopPropagation()
                                                setShowInput(true);
                                                props?.setInfluenceId(props?.item._id);
                                                props?.setItem(props?.item);
                                            }
                                        }}
                                    >
                                        <span
                                            style={
                                                journey?.note?.length > 0
                                                    ? {
                                                        padding: "2px",
                                                        border: `1px solid ${journey?.timeOfDay ? "var(--color-border)" : nearValue ? nearValue : journey.colorCode
                                                            ? journey.colorCode
                                                            : (journey?.type === "TYPE3" &&
                                                                journey?.levelReach === "No") ||
                                                                journey?.levelReach === "No"
                                                                ? (journey?.inverse === "true" ? palette.primary.main : "#F17F79")
                                                                : (journey?.inverse === "true" ? "#F17F79" : "var(--color-new-main)")
                                                            }`,
                                                        borderRadius: journey?.timeOfDay ? "20px" : "50%",
                                                        width: "100%",
                                                        display: "flex",
                                                        height: "100%",
                                                        position: "relative",
                                                    }
                                                    : {
                                                        border: `1px solid ${journey?.timeOfDay ? (outcomeState.isDarkMode ? "var(--dark-border)" : "var(--color-border)") : nearValue ? nearValue : journey.colorCode
                                                            ? journey.colorCode
                                                            : (journey?.type === "TYPE3" &&
                                                                journey?.levelReach === "No") ||
                                                                journey?.levelReach === "No"
                                                                ? (journey?.inverse === "true" ? palette.primary.main : "#F17F79")
                                                                : (journey?.inverse === "true" ? "#F17F79" : "var(--color-new-main)")
                                                            }`,
                                                        backgroundColor: journey?.timeOfDay ? (outcomeState.isDarkMode ? "var(--dark-background)" : "var(--color-border)") : nearValue ? nearValue : journey.colorCode
                                                            ? journey.colorCode
                                                            : (journey?.type === "TYPE3" &&
                                                                journey?.levelReach === "No") ||
                                                                journey?.levelReach === "No"
                                                                ? (journey?.inverse === "true" ? palette.primary.main : "#F17F79")
                                                                : (journey?.inverse === "true" ? "#F17F79" : "var(--color-new-main)"),
                                                        width: "100%",
                                                        borderRadius: journey?.timeOfDay ? "20px" : "50%",
                                                        display: "flex",
                                                        height: "100%",
                                                        position: "relative",
                                                        fontWeight: 600,
                                                        fontSize: "23px",
                                                        lineHeight: "100%",
                                                    }
                                            }
                                        >
                                            <span
                                                style={{
                                                    backgroundColor: journey?.timeOfDay ? (outcomeState.isDarkMode ? "var(--dark-background)" : "var(--color-border)") : nearValue ? nearValue : journey.colorCode
                                                        ? journey.colorCode
                                                        : (journey?.type === "TYPE3" &&
                                                            journey?.levelReach === "No") ||
                                                            journey?.levelReach === "No"
                                                            ? (journey?.inverse === "true" ? palette.primary.main : "#F17F79")
                                                            : (journey?.inverse === "true" ? "#F17F79" : "var(--color-new-main)"),
                                                    borderRadius: journey?.timeOfDay ? "20px" : "50%",
                                                    color: isDarkMode? "var(--dark-background) !important" : "var(--color-text-primary) !important",
                                                    border: `1px solid ${journey?.timeOfDay ? "var(--color-border)" : nearValue ? nearValue : journey.colorCode
                                                        ? journey.colorCode
                                                        : (journey?.type === "TYPE3" &&
                                                            journey?.levelReach === "No") ||
                                                            journey?.levelReach === "No"
                                                            ? (journey?.inverse === "true" ? palette.primary.main : "#F17F79")
                                                            : (journey?.inverse === "true" ? "#F17F79" : "var(--color-new-main)")
                                                        }`,
                                                    width: "100%",
                                                    display: "flex",
                                                    fontWeight: 400,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    ...fontStyling
                                                }}
                                            >
                                                {journey?.timeOfDay ? (
                                                    <Tooltip
                                                        title={
                                                            <Typography
                                                                sx={{
                                                                    fontSize: "10px !important",
                                                                    lineHeight: "1.5",
                                                                }}
                                                            >
                                                                {journey?.timeOfDay}
                                                            </Typography>
                                                        }
                                                    >
                                                        <div className={classes.clock}>
                                                            {journey?.timeOfDay}
                                                        </div>
                                                    </Tooltip>
                                                ) : journey?.type === "TYPE1" ||
                                                    journey?.type === "TYPE12" ? (
                                                    journey?.score
                                                ) : (
                                                    journey?.index
                                                )}
                                            </span>
                                        </span>
                                    </div>
                                );
                            }
                        })}
                        {journeyDataReflective?.map((journey: any, index: number) => {
                            if (
                                journey?.reflectiveId === props?.item?.reflectiveId &&
                                journey?.date === props.headerDate
                            ) {
                                NoData && setNoData(false);
                                return (
                                    <div
                                        key={index}
                                        style={expandedLevelView && journey?.answers[0] ? {
                                            width: "100%",
                                            padding: "0px 24px",
                                            borderRadius: `12px`,
                                            border: `1px solid var(--color-border)`,
                                        } : {
                                            width: "100%",
                                        }}
                                        onClick={e => {
                                            if (expandedLevelView) {
                                                e.stopPropagation()
                                                setShowDescriptionInput(true)
                                                if (props?.item?.reflectiveId && journeyDataReflective && journeyDataReflective.length) {
                                                    let notes = [];
                                                    if (
                                                        journey?.answers &&
                                                        journey?.answers[0]
                                                    ) {
                                                        notes = journey?.answers;
                                                    }
                                                    setNotesInputValue(notes.join("\n"));
                                                }
                                            }

                                        }}
                                    >
                                        {expandedLevelView && journey?.answers[0] && (
                                            <ul
                                                className={classes.notesItem}
                                            >
                                                {journey?.answers?.map(
                                                    (anwerItem: any, index: number) => {
                                                        return (
                                                            <li key={index}>
                                                                <CommonTypo color="var(--color-text-primary)" fontWeight={400}>
                                                                    <span
                                                                        dangerouslySetInnerHTML={{
                                                                            __html:
                                                                                anwerItem.replace(/\n/g, "<br />") ||
                                                                                "",
                                                                        }}
                                                                    ></span>
                                                                </CommonTypo>
                                                            </li>
                                                        );
                                                    }
                                                )}
                                            </ul>
                                        )}
                                        {!expandedLevelView && <span className={classes.plusIcon} style={{
                                            justifyContent: "center"
                                        }}>
                                            <CommonTypo color="var(--color-text-primary)" fontWeight={400}>{journey.answers[0]} {journey.answers.length > 0 ? "..." : ""}</CommonTypo>
                                        </span>}
                                        {/* <span
                                            style={{
                                                backgroundColor: "var(--color-new-main)",
                                                border: `1px solid ${"var(--color-new-main)"}`,
                                                display: "flex",
                                                width: "54px",
                                                height: "100%",
                                            }}
                                        > */}
                                        {/* <span
                                                style={{
                                                    backgroundColor: "var(--color-new-main)",
                                                    borderRadius: "50%",
                                                    border: `1px solid ${"var(--color-new-main)"}`,
                                                }}
                                            >{JSON.stringify(journey.answers)}</span> */}

                                        {/* </span> */}
                                    </div>
                                );
                            }
                        })}
                    </>
                )}
                {!foundData && (!showInput && (!showDescriptionInput)) ?
                    showNewView ? levelRender({}, props?.item) : (
                        (props?.item?.type === "TYPE3") ||
                            (
                                props?.item?.type === "TYPE1" &&
                                props?.item?.flag === "yes") ? (
                            <IconYesNo2 matricValue={null} journalItem={props?.item} onClick={createInfluenceLevel} />
                        ) :
                            <span className={classes.plusIcon} onClick={(e) => {
                                if (
                                    clickCondition &&
                                    props?.item?.type === "TYPE12" &&
                                    props?.item?.flag === "no" &&
                                    !props?.item?.lockMatrix &&
                                    props?.item?.unitValue !== "timeofday"
                                ) {
                                    e.stopPropagation()
                                    setShowInput(true);
                                    props?.setInfluenceId(props?.item._id);
                                    props?.setItem(props?.item);
                                } else if (props?.type === "reflective" && expandedLevelView) {
                                    e.stopPropagation()
                                    setShowDescriptionInput(true)
                                    if (props?.item?.reflectiveId && journeyDataReflective && journeyDataReflective.length) {
                                        setNotesInputValue("");
                                    }
                                } /* else if (
                                    clickCondition &&
                                    props?.item?.type === "TYPE12" &&
                                    props?.item?.unitValue === "timeofday" &&
                                    props?.item?.metric_type === "NEUTRAL"
                                ) {
                                    props?.setOpenTimeOfDayModal(true);
                                    props?.setCategoryId(props?.category?.categoryId)
                                    props.setInfluenceId(props?.item._id);
                                } */
                            }}>
                                {!props?.item?.lockMatrix && <CommonTypo color="var(--color-text-secondary)" size={14} lineHeight={18.2}>{props?.type === "reflective" ? "Add comment..." : `Add ${props?.item?.type === "TYPE12" &&
                                    props?.item?.flag === "no" &&
                                    !props?.item?.lockMatrix &&
                                    props?.item?.unitValue !== "timeofday" ? props?.item?.unitValue : "value"}`}</CommonTypo>}
                                {props?.item?.lockMatrix && isToday && <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.2 2.00004V5.60004C15.2 5.75917 15.1368 5.91178 15.0243 6.0243C14.9117 6.13683 14.7591 6.20004 14.6 6.20004H11C10.8813 6.20013 10.7652 6.165 10.6664 6.09907C10.5676 6.03315 10.4907 5.93941 10.4452 5.82972C10.3998 5.72002 10.3879 5.59931 10.4111 5.48286C10.4343 5.36641 10.4915 5.25945 10.5755 5.17554L11.9487 3.80004C10.844 2.7416 9.37466 2.14842 7.84474 2.14329H7.81099C6.2433 2.14022 4.73744 2.75452 3.61924 3.85329C3.50465 3.96026 3.35276 4.01813 3.19605 4.01454C3.03933 4.01094 2.89025 3.94616 2.78069 3.83406C2.67113 3.72195 2.6098 3.57142 2.60981 3.41466C2.60981 3.25791 2.67117 3.10739 2.78074 2.99529C4.11827 1.68847 5.91176 0.953296 7.78171 0.945317C9.65165 0.937338 11.4514 1.65719 12.8 2.95254L14.177 1.57554C14.261 1.49205 14.3678 1.43528 14.484 1.41238C14.6002 1.38949 14.7206 1.40149 14.83 1.44688C14.9393 1.49227 15.0328 1.56902 15.0987 1.66745C15.1645 1.76589 15.1998 1.88161 15.2 2.00004ZM12.3807 12.1468C11.2694 13.2323 9.78025 13.8444 8.22673 13.8543C6.67322 13.8643 5.17641 13.2712 4.05124 12.2L5.42449 10.8268C5.50927 10.743 5.56718 10.6359 5.59082 10.519C5.61445 10.4022 5.60275 10.281 5.55721 10.1708C5.51167 10.0606 5.43434 9.96653 5.3351 9.9005C5.23585 9.83447 5.11919 9.7995 4.99999 9.80004H1.39999C1.24086 9.80004 1.08825 9.86325 0.975724 9.97578C0.863202 10.0883 0.799988 10.2409 0.799988 10.4V14C0.799895 14.1188 0.835033 14.2349 0.900956 14.3336C0.966878 14.4324 1.06062 14.5094 1.17031 14.5548C1.28001 14.6003 1.40072 14.6121 1.51717 14.589C1.63362 14.5658 1.74057 14.5085 1.82449 14.4245L3.19999 13.0475C4.52914 14.3303 6.30281 15.0494 8.14999 15.0545H8.18974C10.0708 15.0594 11.878 14.323 13.22 13.0048C13.3296 12.8927 13.3909 12.7422 13.3909 12.5854C13.3909 12.4287 13.3296 12.2781 13.22 12.166C13.1105 12.0539 12.9614 11.9891 12.8047 11.9855C12.648 11.9819 12.4961 12.0398 12.3815 12.1468H12.3807Z" fill="#000000" />
                                </svg>}
                            </span>
                    ) : null}
            </div>
            {props?.type !== "reflective" && <div
                className={`${classes.inputContainerFullWidthDescription} ${((props?.type === "outcome" || props?.type === "influence") && foundData?.note?.[0]) && expandedLevelView && classes.inputContainerFullWidthDescriptionWithBorder}`}

                key={`${props?.type === "outcome" ? props?.item?.outcomeId : props?.type === "influence" ? props?.item?.influenceId : props?.item?.reflectiveId}_${props.headerDate}`}
                style={foundData && !((props?.type === "outcome" || props?.type === "influence") && foundData?.note?.[0]) ? {
                    borderColor: "transparent"
                } : {}}
                onClick={(e) => {
                    if (expandedLevelView && foundData) {
                        e.stopPropagation()
                        setShowDescriptionInput(true)
                        if (props?.item?.outcomeId && journeyDataOutcome && journeyDataOutcome.length) {
                            setNotesInputValue(foundData?.note && foundData?.note[0]);
                        }
                        if (props?.item?.influenceId && journeyDataInfluence && journeyDataInfluence.length) {
                            setNotesInputValue(foundData?.note && foundData?.note[0]);
                        }
                        if (props?.item?.reflectiveId && journeyDataReflective && journeyDataReflective.length) {
                            foundData = journeyDataReflective.find(journey => journey?.reflectiveId === props?.item?.reflectiveId &&
                                journey?.date === props.headerDate)
                        }
                    }
                }}
                // id={`${props.headerDate}`}
                id={`${props?.type === "outcome" ? props?.item?.outcomeId : props?.type === "influence" ? props?.item?.influenceId : props?.item?.reflectiveId}_${props.headerDate}`}
            >
                {showDescriptionInput ? (
                    <Box display={"flex"} alignItems={"center"} gap={"8px"} width={"100%"}>
                        <textarea
                            name={props?.item?._id}
                            autoFocus
                            ref={textareaRef}
                            value={inputNotesValue}
                            style={{
                                width: "95%",
                                minHeight: "10px",
                                resize: "none",
                                outline: "none",
                                border: "none"
                            }}
                            className={classes.textAreaClass}
                            onBlur={() => {
                                // let journey = {}
                                // if (props?.type === "outcome") {
                                //     journey = journeyDataOutcome.find(it => it?.outcomeId === props?.item?.outcomeId &&
                                //         it?.date === props.headerDate)
                                // }
                                // if (props?.type === "influence") {
                                //     journey = journeyDataInfluence.find(it => it?.influenceId === props?.item?.influenceId &&
                                //         it?.date === props.headerDate)
                                // }
                                // if (props?.type === "reflective") {
                                //     journey = journeyDataReflective.find(it => it?.reflectiveId === props?.item?.reflectiveId &&
                                //         it?.date === props.headerDate)
                                // }
                                // handleBlurInputAreaInfluence(
                                //     props?.item?.type,
                                //     { key: "kdksjdks", keyCode: "hdj" },
                                //     true,
                                //     journey
                                // );
                            }}
                            onChange={(e) => {
                                setNotesInputValue(e.target.value);
                            }}
                            onKeyDown={(e) => {
                                let journey = {}
                                if (props?.type === "outcome") {
                                    journey = journeyDataOutcome.find(it => it?.outcomeId === props?.item?.outcomeId &&
                                        it?.date === props.headerDate)
                                }
                                if (props?.type === "influence") {
                                    journey = journeyDataInfluence.find(it => it?.influenceId === props?.item?.influenceId &&
                                        it?.date === props.headerDate)
                                }
                                if (props?.type === "reflective") {
                                    journey = journeyDataReflective.find(it => it?.reflectiveId === props?.item?.reflectiveId &&
                                        it?.date === props.headerDate)
                                }
                                handleBlurInputAreaInfluence(
                                    props?.item?.type,
                                    e,
                                    false,
                                    journey
                                );
                            }}
                        />
                        <Button variant="contained" sx={{
                            width: "32px !important",
                            minWidth: "32px !important",
                            height: "18px !important",
                            minHeight: "18px !important",
                            padding: "2px 8px",
                            gap: "8px",
                            borderRadius: "6px",
                            background: "var(--color-new-main)",
                            boxShadow: "none",
                            marginBottom: "0px !important",
                            "&:hover": {
                                background: "var(--color-new-main)",
                                boxShadow: "none",
                            },
                            "&::after": {
                                width: "0px"
                            }
                        }} onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            let journey = {}
                            if (props?.type === "outcome") {
                                journey = journeyDataOutcome.find(it => it?.outcomeId === props?.item?.outcomeId &&
                                    it?.date === props.headerDate)
                            }
                            if (props?.type === "influence") {
                                journey = journeyDataInfluence.find(it => it?.influenceId === props?.item?.influenceId &&
                                    it?.date === props.headerDate)
                            }
                            if (props?.type === "reflective") {
                                journey = journeyDataReflective.find(it => it?.reflectiveId === props?.item?.reflectiveId &&
                                    it?.date === props.headerDate)
                            }
                            handleBlurInputAreaInfluence(
                                props?.item?.type,
                                { key: "kdksjdks", keyCode: "hdj" },
                                true,
                                journey
                            );
                        }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.1633 5.7454L7.01129 12.4809C6.95771 12.5398 6.89404 12.5865 6.82393 12.6183C6.75383 12.6502 6.67867 12.6666 6.60276 12.6666C6.52685 12.6666 6.45169 12.6502 6.38158 12.6183C6.31148 12.5865 6.24781 12.5398 6.19423 12.4809L3.50272 9.53412C3.44907 9.47538 3.40651 9.40565 3.37747 9.32891C3.34844 9.25216 3.3335 9.16991 3.3335 9.08684C3.3335 9.00377 3.34844 8.92152 3.37747 8.84477C3.40651 8.76803 3.44907 8.6983 3.50272 8.63956C3.55637 8.58082 3.62006 8.53423 3.69015 8.50244C3.76025 8.47065 3.83538 8.45429 3.91125 8.45429C3.98712 8.45429 4.06225 8.47065 4.13235 8.50244C4.20244 8.53423 4.26613 8.58082 4.31978 8.63956L6.60324 11.1396L12.3472 4.8519C12.4556 4.73327 12.6025 4.66663 12.7557 4.66663C12.909 4.66663 13.0559 4.73327 13.1643 4.8519C13.2726 4.97052 13.3335 5.13141 13.3335 5.29917C13.3335 5.46694 13.2726 5.62783 13.1643 5.74645L13.1633 5.7454Z" fill="#292B2A" />
                            </svg>
                        </Button>
                    </Box>

                ) : (props?.type === "outcome" || props?.type === "influence") && foundData?.note?.[0] && (
                    <>
                        {(props?.type === "outcome" || props?.type === "influence") && foundData?.note?.[0] ? (
                            <CommonTypo size={16} lineHeight={25.6} color="var(--color-text-secondary)" extraSx={expandedLevelView ? {
                                color: palette.common.black,
                                marginBottom: "0px !important",
                                textAlign: "center",
                                wordBreak: "break-all",
                            } : {
                                color: palette.common.black,
                                marginBottom: "0px !important",
                                display: "-webkit-box", // Required for line clamping
                                WebkitBoxOrient: "vertical", // Required for line clamping
                                WebkitLineClamp: 2, // Number of lines to show before truncating
                                overflow: "hidden", // Hide overflow
                                wordBreak: "break-all",
                                textOverflow: "ellipsis", // Add ellipsis for overflow
                            }}>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: foundData?.note?.[0].replace(/\n/g, "<br />") || "",
                                    }}
                                ></span>
                            </CommonTypo>
                        ) : null}
                        {(props?.type === "reflective") && foundData?.answers?.[0] ? (
                            <CommonTypo color="var(--color-text-secondary)" extraSx={expandedLevelView ? {
                                color: palette.common.black,
                                marginBottom: "0px !important",
                                wordBreak: "break-all",
                            } : {
                                color: palette.common.black,
                                marginBottom: "0px !important",
                                display: "-webkit-box", // Required for line clamping
                                WebkitBoxOrient: "vertical", // Required for line clamping
                                WebkitLineClamp: 2, // Number of lines to show before truncating
                                overflow: "hidden", // Hide overflow
                                wordBreak: "break-all",
                                textOverflow: "ellipsis", // Add ellipsis for overflow
                            }}>
                                {foundData &&
                                    foundData?.answers &&
                                    foundData?.answers[0] && (
                                        <ul
                                            id={`${props?.item?.reflectiveId}_${props.headerDate}`}
                                            className={classes.notesItem}
                                        >
                                            {foundData?.answers?.map(
                                                (anwerItem: any, index: number) => {
                                                    return (
                                                        <li key={index}>
                                                            <Typography
                                                                variant="h5"
                                                                sx={{ color: palette.common.black }}
                                                                component="span"
                                                                title={anwerItem}
                                                            >
                                                                <span
                                                                    dangerouslySetInnerHTML={{
                                                                        __html:
                                                                            anwerItem.replace(/\n/g, "<br />") ||
                                                                            "",
                                                                    }}
                                                                ></span>
                                                            </Typography>
                                                        </li>
                                                    );
                                                }
                                            )}
                                        </ul>
                                    )}
                            </CommonTypo>
                        ) : null}
                    </>
                )}
                {expandedLevelView && !(((props?.type === "outcome" || props?.type === "influence") && foundData?.note?.[0])) && !showDescriptionInput && !props?.item?.lockMatrix ? <span className={classes.plusIcon} style={{
                    display: "flex",
                }}>
                    {!props?.item?.lockMatrix && <CommonTypo color="var(--color-text-secondary)" size={14} lineHeight={18.2}>{props?.type === "reflective" ? "Add answer..." : `Add comment...`}</CommonTypo>}
                </span> : null}
            </div>}
        </div>
    );
};

export default DetailCard